<template>
	<v-container fluid>
		<v-row>
			<v-col cols="12" class="ma-0 pa-0">
				<v-card class="transparent elevation-0">
					<v-card-title primary-title>
						<!-- <v-btn 
							class="mr-2" 
							small 
							dark 
							color="green"
							tile
							@click="dialogAceptar = true"
							v-if="getdatosUsuarioERPERP.iderp != 568"
						>
							Pagar
						</v-btn> -->
						<v-btn 
							class="mr-2" 
							small 
							dark 
							:color="nominaLiberada ? 'red' : 'green'"
							outlined
							@click="toggleLiberarNomina()"
							v-if="getdatosUsuarioERPERP.iderp != 568"
						>
							<v-icon left>{{ nominaLiberada ? 'mdi-lock' : 'mdi-lock-open' }}</v-icon>
							{{ nominaLiberada ? 'Bloquear' : 'Liberar' }}
						</v-btn>

						<v-btn 
							class="mr-2" 
							small 
							dark 
							color="orange"
							outlined
							@click="dialogIniciarRequi = true"
							v-if="getdatosUsuarioERPERP.iderp != 568"
						>
							Subir Requi
						</v-btn>

						<v-spacer></v-spacer>
						<v-btn 
							class="mr-2" 
							small 
							dark 
							outlined
							color="green"
							@click="exportarInscripciones()"
							v-if="getdatosUsuarioERPERP.iderp != 568"
						>
							<v-icon>mdi-microsoft-excel</v-icon>
						</v-btn>

						<v-btn
							color="primary"
							dark
							@click="initialize(), getLiberaNomina( ) "
							small
							outlined
						>
							Actualizar
						</v-btn>
					</v-card-title>
					<v-card-text>

						<v-row>
							<!-- Estatus de nómina -->
							<v-col cols="12">
								<v-chip class="mr-2" dark small :color=" estatusComisiones    ? 'green' : 'green' ">Comisiones</v-chip>
								<v-chip class="mr-2" dark small :color=" estatusHorasExtra    ? 'green' : 'green' ">Horas extra</v-chip>
								<v-chip class="mr-2" dark small :color=" estatusCambioHorario ? 'green' : 'green' ">Cambio horario</v-chip>
								<v-chip              dark small :color=" estatusSinSueldo     ? 'green' : 'green' ">Sueldo</v-chip>
							</v-col>
						</v-row>

						<v-tabs
		          v-model="tab"
		          align-with-title
		        >
		          <v-tabs-slider></v-tabs-slider>

		          <v-tab>Nómina</v-tab>
		          <v-tab v-if="getdatosUsuarioERPERP.iderp != 568">Comparativa</v-tab>
		          <v-tab v-if="getdatosUsuarioERPERP.iderp != 568">Comp. comisiones</v-tab>
		          <v-tab v-if="getdatosUsuarioERPERP.iderp != 568">Comp. Bonos RI</v-tab>
		          <v-tab v-if="getdatosUsuarioERPERP.iderp != 568">Comp. Bonos NI</v-tab>
		          <v-tab v-if="getdatosUsuarioERPERP.iderp != 568">Comp. Bonos Puntualidad</v-tab>
		          <v-tab v-if="getdatosUsuarioERPERP.iderp != 568">Comp. Prima Vacacional</v-tab>
		        </v-tabs>

		        <v-tabs-items v-model="tab">

		        	<!-- Nómina administrativa -->
				      <v-tab-item>
				        <v-card flat>
				          <v-card-text>

				          	<v-radio-group
								      v-model="opcionFiltro"
								      row
								    >
								      <v-radio
								        label="Pendiente"
								        :value="0"
								      ></v-radio>
								      <v-radio
								        label="Aceptados"
								        :value="1"
								      ></v-radio>
								      <v-radio
								        label="Rechazados"
								        :value="2"
								      ></v-radio>
								      <v-radio
								        label="Todos"
								        :value="3"
								      ></v-radio>
								    </v-radio-group>

								    <v-row justify="space-between">

								    	<v-col cols="12" md="6">
										    <div class="black--text">
										    	Avance: {{ nominaActual.filter( el => el.estatus_nomina == 1 ).length ? ( (nominaActual.filter( el => el.estatus_nomina == 1 ).length / nominaActual.length ) *100).toFixed(2) : 0 }} %
										    </div>
								    	</v-col>

								    	<v-col cols="12" md="6">
										    <v-text-field
										      label="Buscar"
										      v-model="search"
										      dense
										      single-line
										      filled
										    ></v-text-field>
								    	</v-col>
								    </v-row>


						        <v-data-table
			            		:headers="headersNomina"
			            		:items="filterEntradas"
			            		class="elevation-0"
			            		:search="search"
			            		:page.sync="page"
			            		@page-count="pageCount = $event"
			            		:mobile-breakpoint="100"
			            		dense
			            		item-key="idchecador"
		            		>
		            			<!-- Valores que ocupan botons, chips, iconos, etc -->
			            		<template v-slot:item.nombre_completo="{ item }">
			            			<span 
			            				:class="item.estatus_nomina == 1 ? 'green--text' : item.estatus_nomina == 2 ? 'red--text' : ''"
			            				@click="verComentarios( item )"
			            				type="button"
			            			>
			            				{{ item.nombre_completo }}
			            			</span>
			            		</template>

			            		<!-- Valores que ocupan botons, chips, iconos, etc -->
			            		<template v-slot:item.tipo_pago="{ item }">
			            			<v-chip v-if="item.tipo_pago == 2" small color="green" dark >Hora</v-chip>
			            			<v-chip v-if="item.tipo_pago == 1" small color="blue" dark >Dia</v-chip>
			            			<v-chip v-if="item.tipo_pago == null || item.tipo_pago == 0" small color="orange" dark >Sin Tipo Pago</v-chip>
			            		</template>

			            		<template v-slot:item.confirmacion_comisiones="{ item }">
			            			<v-chip v-if="(item.confirmacion_comisiones == 3)" small color="green" dark >Aceptadas</v-chip>
			            			<v-chip v-if="(item.confirmacion_comisiones == 4)" small color="blue" dark >Rechazadas</v-chip>
			            			<v-chip v-if="item.puesto == 'Encargada de sucursal' && (item.confirmacion_comisiones == null || item.tipo_pago == 0)" small color="orange" dark >Pendiente</v-chip>
			            		</template>

			            		<template v-slot:item.monto_laborado="{ item }">
			            			<span type="button" @click="goPrenomina(item.nombre_completo )">{{ item.monto_laborado }}</span>
			            		</template>

			            		<template v-slot:item.monto_horas_extras="{ item }">
			            			<span type="button" @click="goHorasExtras(item.nombre_completo )">{{ item.monto_horas_extras }}</span> 
			            		</template>

			            		<template v-slot:item.comisiones_semana="{ item }">
			            			<span type="button" @click="goComisiones(item.nombre_completo )">{{ item.comisiones_semana }}</span>
			            		</template>

			            		<template v-slot:item.monto_total_rebajes="{ item }">
			            			<span type="button" @click="goRebajes(item.nombre_completo )">{{ item.monto_total_rebajes }}</span>
			            		</template>

			            		<template v-slot:item.monto_total_bonos="{ item }">
			            			<span v-if="item.puesto != 'Teacher'" @click="goBonos(item.nombre_completo )">{{ item.monto_total_bonos }}</span>
			            			<span v-if="item.puesto == 'Teacher'" >{{ item.monto_total_bonos }}</span>
			            		</template>

			            		<template v-slot:item.monto_total="{ item }">
			            			<span type="button" @click="formulaMontoTotal(item), dialogMontoTotal = true">{{ item.monto_total }}</span>
			            		</template>

			            		<template v-slot:item.estatus_nomina="{ item }">
			            			<v-chip v-if="item.estatus_nomina == 1" x-small color="success" dark>Aceptada</v-chip>
			            			<v-chip v-else-if="item.estatus_nomina == 2" x-small color="error" dark>Rechazada</v-chip>
			            			<v-chip v-else x-small outlined>Pendiente</v-chip>
			            		</template>

			            		<template v-if="puedeAccionesNomina" v-slot:item.acciones="{ item }">
			            			<div class="d-flex justify-center flex-wrap" style="gap: 4px">
			            				<v-btn
			            					x-small
			            					color="primary"
			            					depressed
			            					:loading="cargar && nominaAccionId === item.id"
			            					:disabled="cargar"
			            					@click="aceptarNominaEmpleado(item)"
			            				>
			            					Aceptar
			            				</v-btn>
			            				<v-btn
			            					v-if="puedeLiberarNominaEmpleado(item)"
			            					x-small
			            					outlined
			            					color="orange darken-2"
			            					:loading="cargar && nominaAccionId === item.id"
			            					:disabled="cargar"
			            					@click="liberarNominaEmpleado(item)"
			            				>
			            					Liberar
			            				</v-btn>
			            			</div>
			            		</template>

				            	<template v-slot:no-data>
				            		<v-btn
					            		color="primary"
					            		@click="initialize"
					            		small
				            		>
				            			Actualizar
					            	</v-btn>
					            </template>
					          </v-data-table>
				          </v-card-text>
				        </v-card>
				      </v-tab-item>

		        	<!-- Comparativa nómina-->
				      <v-tab-item>
				        <v-card flat>
				          <v-card-text 
				          	v-for="(departamento , i) in departamentos" 
				          	:key="i"
				          	class="black--text"
				          >
				        		<div class="text-h6"><b>Departamento:</b> {{ departamento.departamento }}</div>
				          	<v-data-table
			            		:headers="headersComparativa"
			            		:items="departamento.nomina"
			            		class="elevation-0"
			            		:search="search"
			            		:page.sync="page"
			            		@page-count="pageCount = $event"
			            		:mobile-breakpoint="100"
			            		dense
			            		item-key="idchecador"
		            		>

				            	<template v-slot:item.desglose="{ item }">
				            		<v-tooltip bottom v-if="item.tiene_desglose">
				            			<template v-slot:activator="{ on, attrs }">
				            				<v-btn
				            					icon
				            					small
				            					color="primary"
				            					v-bind="attrs"
				            					v-on="on"
				            					@click="abrirDesgloseComparativa(item)"
				            				>
				            					<v-icon small>mdi-file-document-outline</v-icon>
				            				</v-btn>
				            			</template>
				            			<span>Ver desglose de percepción</span>
				            		</v-tooltip>
				            		<span v-else class="grey--text text--lighten-1">—</span>
				            	</template>

				            	<template v-slot:no-data>
				            		<v-btn
					            		color="primary"
					            		@click="initialize"
					            		small
				            		>
				            			Actualizar
					            	</v-btn>
					            </template>
					          </v-data-table>
				          </v-card-text>



				          <v-data-table
		            		:headers="headersComparativaFinal"
		            		:items="comparativaFinal"
		            		class="elevation-0"
		            		:search="search"
		            		:page.sync="page"
		            		@page-count="pageCount = $event"
		            		:mobile-breakpoint="100"
		            		dense
		            		item-key="idchecador"
	            		>

			            	<template v-slot:no-data>
			            		<v-btn
				            		color="primary"
				            		@click="initialize"
				            		small
			            		>
			            			Actualizar
				            	</v-btn>
				            </template>
				          </v-data-table>

				          <v-data-table
		            		:headers="headersComparativaBonosTabla"
		            		:items="comparativaFinalBonos"
		            		class="elevation-0"
		            		:search="search"
		            		:page.sync="page"
		            		@page-count="pageCount = $event"
		            		:mobile-breakpoint="100"
		            		dense
		            		item-key="idchecador"
	            		>

	            			<template v-slot:item.monto_total_ant="{ item }">
								      <v-chip v-if="item.Concepto == 'Bonos RI'" :color="colorChipBonoAnterior('Bonos RI')" dark small>{{ item.monto_total_ant }}</v-chip>
								      <v-chip v-else-if="item.Concepto == 'Bonos NI'" :color="colorChipBonoAnterior('Bonos NI')" dark small>{{ item.monto_total_ant }}</v-chip>
								      <v-chip v-else-if="item.Concepto == 'Bonos Puntualidad'" color="green" dark small>{{ item.monto_total_ant }}</v-chip>
								      <v-chip v-else-if="item.Concepto == 'Prima Vacacional'" color="green" dark small>{{ item.monto_total_ant }}</v-chip>
								      <v-chip v-else color="green" dark small>{{ item.monto_total_ant }}</v-chip>
								    </template>

			            	<template v-slot:no-data>
			            		<v-btn
				            		color="primary"
				            		@click="initialize"
				            		small
			            		>
			            			Actualizar
				            	</v-btn>
				            </template>
				          </v-data-table>

				          <v-data-table
		            		:headers="headersComparativaFinal"
		            		:items="comparativaFinalFinal"
		            		class="elevation-0"
		            		:search="search"
		            		:page.sync="page"
		            		@page-count="pageCount = $event"
		            		:mobile-breakpoint="100"
		            		dense
		            		item-key="idchecador"
	            		>

			            	<template v-slot:no-data>
			            		<v-btn
				            		color="primary"
				            		@click="initialize"
				            		small
			            		>
			            			Actualizar
				            	</v-btn>
				            </template>
				          </v-data-table>

				          <div class="text-h6 mt-8 mb-1 black--text"><b>Comparativa de horas (reloj checador)</b></div>
				          <div class="caption grey--text mb-2" v-if="rangosHoras.actual">
				          	Semana actual: {{ formatoRangoHoras(rangosHoras.actual) }}
				          	<span v-if="rangosHoras.anterior"> · Semana anterior: {{ formatoRangoHoras(rangosHoras.anterior) }}</span>
				          	· Sábado a domingo
				          </div>
				          <v-data-table
				          	:headers="headersComparativaHoras"
				          	:items="comparativaHorasVista"
				          	class="elevation-0"
				          	:search="search"
				          	:loading="cargandoHoras"
				          	:mobile-breakpoint="100"
				          	dense
				          	item-key="id"
				          	:items-per-page="50"
				          	:footer-props="{ 'items-per-page-options': [25, 50, 100, -1] }"
				          >
				          	<template v-slot:item.diferencia="{ item }">
				          		<span :class="colorDiferenciaHoras(item.diferencia_minutos)">{{ item.diferencia }}</span>
				          	</template>
				          	<template v-slot:no-data>
				          		<span class="grey--text">Sin chequeos para comparar</span>
				          	</template>
				          </v-data-table>

				          <div class="text-h6 mt-8 mb-3 black--text"><b>Resumen de horas por departamento</b></div>
				          <v-row class="mb-2">
				          	<v-col cols="12" sm="4">
				          		<v-card outlined class="pa-3">
				          			<div class="caption grey--text d-flex align-center">
				          				Horas semana pasada
				          				<v-tooltip bottom max-width="260">
				          					<template v-slot:activator="{ on, attrs }">
				          						<v-icon x-small class="ml-1" color="grey" v-bind="attrs" v-on="on">mdi-information-outline</v-icon>
				          					</template>
				          					<span>Suma de horas registradas de todos los trabajadores en la semana anterior</span>
				          				</v-tooltip>
				          			</div>
				          			<div class="text-h5 font-weight-bold">{{ kpiHorasTotal.horas_ant }}</div>
				          		</v-card>
				          	</v-col>
				          	<v-col cols="12" sm="4">
				          		<v-card outlined class="pa-3">
				          			<div class="caption grey--text d-flex align-center">
				          				Horas semana actual
				          				<v-tooltip bottom max-width="260">
				          					<template v-slot:activator="{ on, attrs }">
				          						<v-icon x-small class="ml-1" color="grey" v-bind="attrs" v-on="on">mdi-information-outline</v-icon>
				          					</template>
				          					<span>Suma de horas registradas de todos los trabajadores en la semana actual</span>
				          				</v-tooltip>
				          			</div>
				          			<div class="text-h5 font-weight-bold">{{ kpiHorasTotal.horas_act }}</div>
				          		</v-card>
				          	</v-col>
				          	<v-col cols="12" sm="4">
				          		<v-card outlined class="pa-3">
				          			<div class="caption grey--text d-flex align-center">
				          				Diferencia general
				          				<v-tooltip bottom max-width="280">
				          					<template v-slot:activator="{ on, attrs }">
				          						<v-icon x-small class="ml-1" color="grey" v-bind="attrs" v-on="on">mdi-information-outline</v-icon>
				          					</template>
				          					<span>Horas semana actual menos horas semana pasada. Positivo = se trabajó más; negativo = se trabajó menos</span>
				          				</v-tooltip>
				          			</div>
				          			<div class="text-h5 font-weight-bold" :class="colorDiferenciaHoras(kpiHorasTotal.diferencia_minutos)">
				          				{{ kpiHorasTotal.diferencia }}
				          			</div>
				          		</v-card>
				          	</v-col>
				          </v-row>

				          <v-data-table
				          	:headers="headersKpiHorasDepto"
				          	:items="kpiHorasDepartamentos"
				          	class="elevation-0"
				          	:mobile-breakpoint="100"
				          	dense
				          	hide-default-footer
				          	disable-pagination
				          	item-key="departamento"
				          >
				          	<template v-slot:header.personas="{ header }">
				          		<span class="d-inline-flex align-center">
				          			{{ header.text }}
				          			<v-tooltip bottom max-width="240">
				          				<template v-slot:activator="{ on, attrs }">
				          					<v-icon x-small class="ml-1" color="grey" v-bind="attrs" v-on="on">mdi-information-outline</v-icon>
				          				</template>
				          				<span>Cantidad de trabajadores del departamento incluidos en la comparativa</span>
				          			</v-tooltip>
				          		</span>
				          	</template>
				          	<template v-slot:header.horas_ant="{ header }">
				          		<span class="d-inline-flex align-center">
				          			{{ header.text }}
				          			<v-tooltip bottom max-width="260">
				          				<template v-slot:activator="{ on, attrs }">
				          					<v-icon x-small class="ml-1" color="grey" v-bind="attrs" v-on="on">mdi-information-outline</v-icon>
				          				</template>
				          				<span>Total de horas del departamento en la semana anterior (primer vs último chequeo del día)</span>
				          			</v-tooltip>
				          		</span>
				          	</template>
				          	<template v-slot:header.horas_act="{ header }">
				          		<span class="d-inline-flex align-center">
				          			{{ header.text }}
				          			<v-tooltip bottom max-width="260">
				          				<template v-slot:activator="{ on, attrs }">
				          					<v-icon x-small class="ml-1" color="grey" v-bind="attrs" v-on="on">mdi-information-outline</v-icon>
				          				</template>
				          				<span>Total de horas del departamento en la semana actual (primer vs último chequeo del día)</span>
				          			</v-tooltip>
				          		</span>
				          	</template>
				          	<template v-slot:header.horas_mas="{ header }">
				          		<span class="d-inline-flex align-center">
				          			{{ header.text }}
				          			<v-tooltip bottom max-width="280">
				          				<template v-slot:activator="{ on, attrs }">
				          					<v-icon x-small class="ml-1" color="grey" v-bind="attrs" v-on="on">mdi-information-outline</v-icon>
				          				</template>
				          				<span>Suma solo de quienes trabajaron más horas esta semana respecto a la anterior</span>
				          			</v-tooltip>
				          		</span>
				          	</template>
				          	<template v-slot:header.horas_menos="{ header }">
				          		<span class="d-inline-flex align-center">
				          			{{ header.text }}
				          			<v-tooltip bottom max-width="280">
				          				<template v-slot:activator="{ on, attrs }">
				          					<v-icon x-small class="ml-1" color="grey" v-bind="attrs" v-on="on">mdi-information-outline</v-icon>
				          				</template>
				          				<span>Suma solo de quienes trabajaron menos horas esta semana respecto a la anterior</span>
				          			</v-tooltip>
				          		</span>
				          	</template>
				          	<template v-slot:header.diferencia="{ header }">
				          		<span class="d-inline-flex align-center">
				          			{{ header.text }}
				          			<v-tooltip bottom max-width="300">
				          				<template v-slot:activator="{ on, attrs }">
				          					<v-icon x-small class="ml-1" color="grey" v-bind="attrs" v-on="on">mdi-information-outline</v-icon>
				          				</template>
				          				<span>Balance del departamento: horas actuales − horas pasadas. Es el resultado neto (subidas menos bajadas)</span>
				          			</v-tooltip>
				          		</span>
				          	</template>
				          	<template v-slot:item.diferencia="{ item }">
				          		<span :class="colorDiferenciaHoras(item.diferencia_minutos)">{{ item.diferencia }}</span>
				          	</template>
				          	<template v-slot:item.horas_mas="{ item }">
				          		<span class="green--text">{{ item.horas_mas }}</span>
				          	</template>
				          	<template v-slot:item.horas_menos="{ item }">
				          		<span class="red--text">{{ item.horas_menos }}</span>
				          	</template>
				          </v-data-table>
				        </v-card>
				      </v-tab-item>

				      <!-- Comparativa de comisiones -->
				      <v-tab-item>
				        <v-card flat>
				          <v-card-text class="black--text">
				          	<v-data-table
			            		:headers="headersComparativaComisiones"
			            		:items="comparativaComisiones"
			            		class="elevation-0"
			            		:search="search"
			            		:page.sync="page"
			            		@page-count="pageCount = $event"
			            		:mobile-breakpoint="100"
			            		dense
			            		item-key="idchecador"
		            		>

				            	<template v-slot:no-data>
				            		<v-btn
					            		color="primary"
					            		@click="initialize"
					            		small
				            		>
				            			Actualizar
					            	</v-btn>
					            </template>
					          </v-data-table>
				          </v-card-text>
				        </v-card>
				      </v-tab-item>

				      <!-- Comparativa de bono RI -->
				      <v-tab-item>
				        <v-card flat>
				          <v-card-text class="black--text">
				          	<v-data-table
			            		:headers="headerscomparativaRI"
			            		:items="bonosRi"
			            		class="elevation-0"
			            		:search="search"
			            		:page.sync="page"
			            		@page-count="pageCount = $event"
			            		:mobile-breakpoint="100"
			            		dense
			            		item-key="idchecador"
		            		>

				            	<template v-slot:no-data>
				            		<v-btn
					            		color="primary"
					            		@click="initialize"
					            		small
				            		>
				            			Actualizar
					            	</v-btn>
					            </template>
					          </v-data-table>
				          </v-card-text>
				        </v-card>
				      </v-tab-item>

				      <!-- Comparativa de bono NI -->
				      <v-tab-item>
				        <v-card flat>
				          <v-card-text class="black--text">
				          	<v-data-table
			            		:headers="headerscomparativaNI"
			            		:items="bonosNI"
			            		class="elevation-0"
			            		:search="search"
			            		:page.sync="page"
			            		@page-count="pageCount = $event"
			            		:mobile-breakpoint="100"
			            		dense
			            		item-key="idchecador"
		            		>

				            	<template v-slot:no-data>
				            		<v-btn
					            		color="primary"
					            		@click="initialize"
					            		small
				            		>
				            			Actualizar
					            	</v-btn>
					            </template>
					          </v-data-table>
				          </v-card-text>
				        </v-card>
				      </v-tab-item>

				      <!-- Comparativa de bono Puntualidad -->
				      <v-tab-item>
				        <v-card flat>
				          <v-card-text class="black--text">
				          	<v-data-table
			            		:headers="headerscomparativaPuntualidad"
			            		:items="bonosPu"
			            		class="elevation-0"
			            		:search="search"
			            		:page.sync="page"
			            		@page-count="pageCount = $event"
			            		:mobile-breakpoint="100"
			            		dense
			            		item-key="idchecador"
		            		>

				            	<template v-slot:no-data>
				            		<v-btn
					            		color="primary"
					            		@click="initialize"
					            		small
				            		>
				            			Actualizar
					            	</v-btn>
					            </template>
					          </v-data-table>
				          </v-card-text>
				        </v-card>
				      </v-tab-item>

				      <!-- Comparativa Prima Vacacional -->
				      <v-tab-item>
				        <v-card flat>
				          <v-card-text class="black--text">
				          	<v-data-table
			            		:headers="headerscomparativaPrimaVac"
			            		:items="bonosPrimaVac"
			            		class="elevation-0"
			            		:search="search"
			            		:page.sync="page"
			            		@page-count="pageCount = $event"
			            		:mobile-breakpoint="100"
			            		dense
			            		item-key="id"
		            		>
				            	<template v-slot:no-data>
				            		<v-btn
					            		color="primary"
					            		@click="initialize"
					            		small
				            		>
				            			Actualizar
					            	</v-btn>
					            </template>
					          </v-data-table>
				          </v-card-text>
				        </v-card>
				      </v-tab-item>

				    </v-tabs-items>
			    </v-card-text>
				</v-card> 
			</v-col>

			<v-dialog v-model="dialogAceptar" max-width="500px">
				<v-card>
					<v-card-text>
							<v-row>
							<v-col cols="6">
								<v-card class="elevation-0" height="100%" style="display: table">
									<div
									class="text-h6"
									style="display: table-cell; vertical-align: middle"
									>
									<strong>Aceptar:</strong> ¿Estás seguro que deseas guardar la nómina?
									<v-card-actions class="pt-6">
										<!-- Cerrar dialogo de confirmación y abrir el dialogo de editar la clase -->
										<v-btn
										color="error"
										text
										large
										class="mr-2"
										@click="dialogAceptar=false"
										>No, cancelar</v-btn
										>
										<!-- Guardar la información  -->
										<v-btn
										color="#5C5C5C"
										dark
										class="elevation-6"
										large
										@click="dialogAceptar = false, subirNomina()"
										>Si</v-btn
										>
									</v-card-actions>
								</div>
								</v-card>
							</v-col>
							<v-col cols="6">
								<v-img src="@/assets/contrato.jpg"></v-img>
							</v-col>
						</v-row>
					</v-card-text>
				</v-card>
			</v-dialog>

			<v-dialog v-model="dialogIniciarRequi" max-width="1400px">
				<v-card>
					<v-card-title primary-title class="subtitle-1" >
					  Revisión de requisición
					  <v-spacer></v-spacer>
						<v-btn
							color="green"
							dark
							@click="subirNomina()"
						>Subir Requisición</v-btn>
					</v-card-title>
					<v-card-text>
						<v-row>
							<!-- Seleccionar la requisición -->
							<v-col>
								<v-radio-group
						      v-model="opEscuela"
						      row
						    >
						      <v-radio
						        label="Inbi"
						        :value="1"
						      ></v-radio>
						      <v-radio
						        label="Fast"
						        :value="2"
						      ></v-radio>
						    </v-radio-group>
							</v-col>

							<!-- Seleccionar el tipo de requisición -->
							<v-col>
								<v-radio-group
						      v-model="opRquisicion"
						      row
						    >
						      <v-radio
						        label="Operativa"
						        :value="1"
						      ></v-radio>
						      <v-radio
						        label="Comisiones"
						        :value="2"
						      ></v-radio>
						      <v-radio
						        label="Bonos"
						        :value="3"
						      ></v-radio>
						    </v-radio-group>
							</v-col>
						</v-row>

						<v-row>
							<v-col cols="12" v-if="opRquisicion == 1 && opEscuela == 1">
								<v-data-table
	            		:headers="headerRequi"
	            		:items="generaRequiOperativaInbi( nominaActual )"
	            		class="elevation-0"
	            		dense
	          		>
	          			<template v-slot:item.costo_unitario="{ item }">
	            			<span>{{ format( item.costo_unitario ) }}</span>
	            		</template>

									<template v-slot:item.costo_total="{ item }">
	            			<span>{{ format( item.costo_total ) }}</span>
	            		</template>

			          </v-data-table>
							</v-col>

							<v-col cols="12" v-if="opRquisicion == 1 && opEscuela == 2">
								<v-data-table
	            		:headers="headerRequi"
	            		:items="generaRequiOperativaFast( nominaActual )"
	            		class="elevation-0"
	            		dense
	          		>
	          			<template v-slot:item.costo_unitario="{ item }">
	            			<span>{{ format( item.costo_unitario ) }}</span>
	            		</template>

									<template v-slot:item.costo_total="{ item }">
	            			<span>{{ format( item.costo_total ) }}</span>
	            		</template>

			          </v-data-table>
							</v-col>


							<v-col cols="12" v-if="opRquisicion == 2 && opEscuela == 1">
								<v-data-table
	            		:headers="headerRequi"
	            		:items="generaRequiComisionesInbi( nominaActual )"
	            		class="elevation-0"
	            		dense
	          		>
	          			<template v-slot:item.costo_unitario="{ item }">
	            			<span>{{ format( item.costo_unitario ) }}</span>
	            		</template>

									<template v-slot:item.costo_total="{ item }">
	            			<span>{{ format( item.costo_total ) }}</span>
	            		</template>

			          </v-data-table>
							</v-col>

							<v-col cols="12" v-if="opRquisicion == 2 && opEscuela == 2">
								<v-data-table
	            		:headers="headerRequi"
	            		:items="generaRequiComisionesFast( nominaActual )"
	            		class="elevation-0"
	            		dense
	          		>
	          			<template v-slot:item.costo_unitario="{ item }">
	            			<span>{{ format( item.costo_unitario ) }}</span>
	            		</template>

									<template v-slot:item.costo_total="{ item }">
	            			<span>{{ format( item.costo_total ) }}</span>
	            		</template>

			          </v-data-table>
							</v-col>

							<v-col cols="12" v-if="opRquisicion == 3 && opEscuela == 1">
								<v-data-table
	            		:headers="headerRequi"
	            		:items="generaRequiBonosInbi( nominaActual) "
	            		class="elevation-0"
	            		dense
	          		>
	          			<template v-slot:item.costo_unitario="{ item }">
	            			<span>{{ format( item.costo_unitario ) }}</span>
	            		</template>

									<template v-slot:item.costo_total="{ item }">
	            			<span>{{ format( item.costo_total ) }}</span>
	            		</template>

			          </v-data-table>
							</v-col>

							<v-col cols="12" v-if="opRquisicion == 3 && opEscuela == 2">
								<v-data-table
	            		:headers="headerRequi"
	            		:items="generaRequiBonosFast( nominaActual) "
	            		class="elevation-0"
	            		dense
	          		>
	          			<template v-slot:item.costo_unitario="{ item }">
	            			<span>{{ format( item.costo_unitario ) }}</span>
	            		</template>

									<template v-slot:item.costo_total="{ item }">
	            			<span>{{ format( item.costo_total ) }}</span>
	            		</template>

			          </v-data-table>
							</v-col>

						</v-row>

					</v-card-text>
				</v-card>
			</v-dialog>
		</v-row>

		<v-dialog
		  v-model="dialogComentarios"
		  max-width="500px"
		  v-if="renglonNomina"
		>
			<v-card>
				<v-card-title primary-title>
				  Comentarios de nómina
				</v-card-title>

			  <v-card-text>
			  	<v-row>
			  		<v-col cols="12"
			  			v-for="(mensaje, i) in renglonNomina.comentarios" :key="i"
			  		>
					  	<p 
					  		:class="`pa-2 ma-0 mb-4 ${ mensaje.id_usuario != getdatosUsuarioERPERP.id_trabajador ? 'mensajeIzq' : 'mensajeDer' }`">
					    	{{ mensaje.comentarios }}
					    	<br/>
					    	{{ mensaje.nombre_completo }}
					  	</p>
			  		</v-col>
			  	</v-row>
			    <br/>
			  </v-card-text>

			  <v-card-text>
			    <v-textarea
			  		v-model="respuesta"
			  		filled
			  		:rows="3"
			  		auto-grow
			  		label="respuesta al colaborador"
			  		hide-details
			  	></v-textarea>
			  </v-card-text>
			  
			  <v-card-actions>
			  	<v-btn 
			  		color="black"
			  		@click="dialogComentarios = false"
			  		tile
			  		dark
			  		small
			  	>
			  		<v-icon left span>mdi-cancel</v-icon>
			  		Cancelar
			  	</v-btn>
			    <v-spacer></v-spacer>
			  	<v-btn 
			  		color="success"
			  		@click="responder( )"
			  		tile
			  		small
			  	>
			  		<v-icon left span>mdi-content-save</v-icon>
			  		responder
			  	</v-btn>
			  </v-card-actions>
			</v-card>	
		</v-dialog>

		<!-- Desglose percepción — Comparativa -->
		<v-dialog
			v-model="dialogDesgloseComparativa"
			max-width="640"
			scrollable
		>
			<v-card v-if="desgloseComparativa">
				<v-card-title class="text-h6 py-3">
					<v-icon left color="primary">mdi-file-document-outline</v-icon>
					Desglose de percepción
					<v-spacer></v-spacer>
					<v-btn icon small @click="dialogDesgloseComparativa = false">
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-divider></v-divider>

				<v-card-subtitle class="pb-0 pt-3">
					<div class="text-body-2 font-weight-medium black--text">{{ desgloseComparativa.nombre }}</div>
					<div class="caption grey--text">
						{{ desgloseComparativa.puesto }}
						<span v-if="desgloseComparativa.plantel"> · {{ desgloseComparativa.plantel }}</span>
					</div>
				</v-card-subtitle>

				<v-card-text class="pt-3" style="max-height: 70vh;">
					<div
						v-for="(seccion, sIdx) in desgloseComparativa.secciones"
						:key="'sec-' + sIdx"
						class="mb-4"
					>
						<div class="text-subtitle-2 font-weight-bold mb-1 d-flex align-center">
							<v-icon small left :color="seccion.color">{{ seccion.icon }}</v-icon>
							{{ seccion.titulo }}
						</div>
						<div v-if="seccion.hint" class="caption grey--text mb-2">{{ seccion.hint }}</div>

						<v-simple-table dense class="elevation-0">
							<tbody>
								<tr v-for="(linea, lIdx) in seccion.lineas" :key="'l-' + sIdx + '-' + lIdx">
									<td class="pl-0" :class="linea.esTotal || linea.esSubtotal ? 'font-weight-medium' : ''">
										{{ linea.label }}
										<div v-if="linea.hint" class="caption grey--text">{{ linea.hint }}</div>
									</td>
									<td
										class="text-right pr-0"
										:class="{
											'font-weight-bold': linea.esTotal || linea.esSubtotal,
											'success--text': linea.esTotal,
											'error--text': linea.esDescuento && linea.valorNum !== 0,
											'primary--text': linea.esSubtotal && !linea.esDescuento,
										}"
									>
										{{ linea.valor }}
									</td>
								</tr>
							</tbody>
						</v-simple-table>
						<v-divider v-if="sIdx < desgloseComparativa.secciones.length - 1" class="mt-2"></v-divider>
					</div>

					<v-alert
						dense
						text
						:type="desgloseComparativa.cuadra ? 'success' : 'warning'"
						class="mb-0"
					>
						<div class="d-flex justify-space-between align-center">
							<span>
								{{ desgloseComparativa.cuadra
									? 'El desglose cuadra con el monto final del sistema.'
									: 'Hay una diferencia entre el desglose y el monto final.' }}
							</span>
							<span class="font-weight-bold ml-2">{{ desgloseComparativa.diferenciaTexto }}</span>
						</div>
					</v-alert>
				</v-card-text>

				<v-divider></v-divider>
				<v-card-actions class="pa-4">
					<div class="caption grey--text">
						Fórmula: (Jornada + Extras + Comisiones + Bonos + Compensaciones) − Rebajes
					</div>
					<v-spacer></v-spacer>
					<v-btn color="primary" tile dark small @click="dialogDesgloseComparativa = false">
						Cerrar
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<!-- Dialog de carga -->
		<Alerta               v-if="respuestaAlerta"             :parametros="parametros"/>
		<carga                v-if="cargar"/>

	</v-container>
</template>
<script>
	import axios from 'axios';
	import { mapGetters } from 'vuex'
	// Componentes
	import Alerta                from '@/components/alertas/Alerta.vue'
	import carga                 from '@/components/alertas/carga.vue';


	import validarErrores  from '@/mixins/validarErrores'
	import XLSX            from 'xlsx'
	import funcionesExcel  from '@/mixins/funcionesExcel'
	import liberaNomina    from '@/mixins/liberaNomina'
	import requiNomina     from '@/mixins/requiNomina'
	import mixinNominaAdministrativaGuard from '@/mixins/mixinNominaAdministrativaGuard'


	export default {
		components:{
			Alerta,
			carga,
		},

		mixins: [ validarErrores, funcionesExcel, liberaNomina, requiNomina, mixinNominaAdministrativaGuard ],

		props:[
			'selectedHeaders',
			'ciclo',
			'ciclosLista',
			'fecha'
		],


		data: () => ({
    	// Alertas
			parametros:{
				dialogError: false,
				mensaje: '',
				color: ''
			},

			respuestaAlerta:false,
			loader: true,
			cargar: false,

			dialogAceptar: false,
			dialogActualizar: false,
			ciclos:[],
			gruposRoles: [],
			pagos: [],
			id_ciclo: 0,

      // tabla
			search:'',
			search2:'',
			formula_monto_laborado:'',
			formula_horas_extras:'',
			formula_monto_rebajes:'',
			formula_monto_bonos:'',
			formula_monto_total:'',
			page: 1,
			page2: 1,
			pageCount: 0,
			itemsPerPage: 10,
			nominaActual: [],
			nominaLiberada: false,
			nomina_pasada: [],
			nominaSemanal: [],
			autorizarNomina: [],
			nominaEstatus: [],
			asistencias: [],
			estatus: null,
			entradassalidasteachers: [],
			horasDobles:[],
			horasTotales: 0,

			headers: [
				{ text: 'Empleado'              , value: 'nombre_completo'      },
				{ text: 'Puesto'                , value: 'puesto'               },
				{ text: 'Plantel'               , value: 'plantel'              },
				{ text: 'Monto Jornada Laboral' , value: 'monto_laborado'       , align: 'end'},
				{ text: 'Monto Horas Extras'    , value: 'monto_horas_extras'   , align: 'end'},
				{ text: 'Monto Comisiones'      , value: 'comisiones_semana'    , align: 'end'},
				{ text: 'Monto Rebajes'         , value: 'monto_total_rebajes'  , align: 'end'},
				{ text: 'Monto Bonos'           , value: 'monto_total_bonos'    , align: 'end'},
				{ text: 'Monto Total'           , value: 'monto_total'          , align: 'end'},
				{ text: 'Estatus'               , value: 'estatus_nomina'       , align: 'center', sortable: false, width: '110px' },
			],

			headersAccionesNomina: [
				{ text: 'Acciones'              , value: 'acciones'             , align: 'center', sortable: false, width: '150px' },
			],

			usuariosAccionesNomina: [1, 334, 966],

			headersComparativa: [
				{ text: 'Empleado'     , value: 'nombre_completo'      },
				{ text: 'Puesto'       , value: 'puesto'               },
				{ text: 'Plantel'      , value: 'plantel'              },
				{ text: 'Monto Ant'    , value: 'monto_total_ant'      , align: 'end' },
				{ text: 'Monto Act'    , value: 'monto_total_act'      , align: 'end' },
				{ text: 'Difencia'     , value: 'diferencia'           , align: 'end' },
				{ text: 'Motivo'       , value: 'motivo'               },
				{ text: 'Desglose'     , value: 'desglose'             , sortable: false, align: 'center', width: '90px' },
			],

			headersComparativaFinal: [
				{ text: 'Empleado'     , value: 'Concepto'                            },
				{ text: 'Monto Ant'    , value: 'monto_total_ant'      , align: 'end' },
				{ text: 'Monto Act'    , value: 'monto_total_act'      , align: 'end' },
				{ text: 'Difencia'     , value: 'diferencia'           , align: 'end' },
			],
			headersComparativaFinal2: [
				{ text: 'Empleado'     , value: 'Concepto'                            },
				{ text: 'Monto Ant'    , value: 'monto_total_ant'      , align: 'end' },
				{ text: 'Monto Act'    , value: 'monto_total_act'      , align: 'end' },
				{ text: 'Difencia'     , value: 'diferencia'           , align: 'end' },
				{ text: 'Difencia Real', value: 'diferenciareal'       , align: 'end' },
			],

			headersComparativaComisiones: [
				{ text: 'Empleado'     , value: 'nombre_completo'                                },
				{ text: 'Puesto'       , value: 'puesto'                                         },
				{ text: 'Plantel'      , value: 'plantel'                                        },
				{ text: 'Monto Ant'    , value: 'monto_total_ant_comisiones'      , align: 'end' },
				{ text: 'Monto Act'    , value: 'monto_total_act_comisiones'      , align: 'end' },
				{ text: 'Difencia'     , value: 'diferencia_comisiones'           , align: 'end' },
			],

			headerscomparativaRI: [
				{ text: 'Empleado'     , value: 'nombre_completo'                   },
				{ text: 'Puesto'       , value: 'puesto'                            },
				{ text: 'Plantel'      , value: 'plantel'                           },
				{ text: 'Monto Ant'    , value: 'bono_ri'            , align: 'end' },
				{ text: 'Monto Act'    , value: 'monto_total_act'    , align: 'end' },
				{ text: 'Difencia'     , value: 'diferencia'         , align: 'end' },
			],

			headerscomparativaNI: [
				{ text: 'Empleado'     , value: 'nombre_completo'                   },
				{ text: 'Puesto'       , value: 'puesto'                            },
				{ text: 'Plantel'      , value: 'plantel'                           },
				{ text: 'Monto Ant'    , value: 'bono_ni'            , align: 'end' },
				{ text: 'Monto Act'    , value: 'monto_total_act'    , align: 'end' },
				{ text: 'Difencia'     , value: 'diferencia'         , align: 'end' },
			],

			headerscomparativaPuntualidad: [
				{ text: 'Empleado'     , value: 'nombre_completo'                   },
				{ text: 'Puesto'       , value: 'puesto'                            },
				{ text: 'Plantel'      , value: 'plantel'                           },
				{ text: 'Monto Ant'    , value: 'puntualidad'        , align: 'end' },
				{ text: 'Monto Act'    , value: 'monto_total_act'    , align: 'end' },
				{ text: 'Difencia'     , value: 'diferencia'         , align: 'end' },
			],

			headerscomparativaPrimaVac: [
				{ text: 'Empleado'     , value: 'nombre_completo'                         },
				{ text: 'Puesto'       , value: 'puesto'                                  },
				{ text: 'Plantel'      , value: 'plantel'                                 },
				{ text: 'Monto Ant'    , value: 'prima_vacacional'        , align: 'end' },
				{ text: 'Monto Act'    , value: 'monto_total_act'         , align: 'end' },
				{ text: 'Difencia'     , value: 'diferencia'              , align: 'end' },
			],

			headersComparativaHoras: [
				{ text: 'Trabajador'          , value: 'nombre_completo'     },
				{ text: 'Puesto'              , value: 'puesto'              },
				{ text: 'Plantel'             , value: 'plantel'             },
				{ text: 'Horas semana pasada' , value: 'horas_ant'           , align: 'end' },
				{ text: 'Horas semana actual' , value: 'horas_act'           , align: 'end' },
				{ text: 'Diferencia'          , value: 'diferencia'          , align: 'end' },
			],

			headersKpiHorasDepto: [
				{ text: 'Departamento'        , value: 'departamento'        },
				{ text: 'Personas'            , value: 'personas'            , align: 'end' },
				{ text: 'Horas semana pasada' , value: 'horas_ant'           , align: 'end' },
				{ text: 'Horas semana actual' , value: 'horas_act'           , align: 'end' },
				{ text: 'Horas de más'        , value: 'horas_mas'           , align: 'end' },
				{ text: 'Horas de menos'      , value: 'horas_menos'         , align: 'end' },
				{ text: 'Diferencia neta'     , value: 'diferencia'          , align: 'end' },
			],

			headerRequi: [
				{ text: 'ID Empleado'   , value: 'id_empleado'     },
				{ text: 'Concepto'      , value: 'concepto'        },
				{ text: 'Plantel'       , value: 'plantel'         },
				{ text: 'Elemento'      , value: 'elemento'        , align: 'end' },
				{ text: 'Costo U.'      , value: 'costo_unitario'  , align: 'end' },
				{ text: 'Costo T'       , value: 'costo_total'     , align: 'end' },
			],


			tab: null,
			dataNominaAnterior: [],

			renglonNomina: null,
			dialogComentarios: false,
			respuesta: '',
			opcionFiltro: 3,
			departamentos:[],

			comparativaComisiones:[],
			bonosRi: [],
			bonosNI: [],
			bonosPu: [],
			bonosPrimaVac: [],
			bonosClases: [],

			totalAnterior: 0,
			totalActual:0,
			diferenciaTotal: 0,

			comparativaFinal:[],
			comparativaFinalBonos:[],
			comparativaFinalFinal:[],
			comparativaHoras:[],
			cargandoHoras: false,
			rangosHoras: {
				actual: null,
				anterior: null,
			},

			compensacionesAct: 0,
			compensacionesAnt: 0,

			dialogDesgloseComparativa: false,
			desgloseComparativa: null,

			estatusComisiones: false,
			estatusHorasExtra: false,
			estatusCambioHorario: false,
			estatusSinSueldo: false,
			dialogIniciarRequi: false,
			opRquisicion: 1,
			opEscuela: 1,
			historialNomina:[],
			nominaAccionId: null,
		}),

		computed: {

			...mapGetters( 'login' ,['getdatosUsuarioERPERP']),

			puedeAccionesNomina() {
				return this.usuariosAccionesNomina.includes(
					this.getdatosUsuarioERPERP.iderp
				)
			},

			headersNomina() {
				if (this.puedeAccionesNomina) {
					return this.headers.concat(this.headersAccionesNomina)
				}
				return this.headers
			},

			filterEntradas( ){
				let entradass = this.nominaActual
				if( this.opcionFiltro != 3 ){

					entradass = entradass.filter( el => el.estatus_nomina == this.opcionFiltro )

				} 
				return entradass
			},

			filterEntradasEncargadas( ){
				let entradass = this.nominaActual;



				return entradass.filter(el => el.puesto !== 'Sin puesto' && el.puesto == 'Encargada de sucursal');
			},

			comparativaHorasVista(){
				const nomina = this.nominaActual || []
				const porId = {}
				nomina.forEach(el => { porId[Number(el.id)] = el })

				const ids = nomina.map(el => Number(el.id))
				const lista = ids.length
					? this.comparativaHoras.filter(el => ids.includes(Number(el.id)))
					: this.comparativaHoras

				return lista.map(el => {
					const nom = porId[Number(el.id)]
					return {
						...el,
						departamento: (nom && nom.departamento) || el.departamento || 'Sin departamento',
					}
				})
			},

			kpiHorasDepartamentos(){
				const grupos = {}

				this.comparativaHorasVista.forEach(el => {
					const depto = el.departamento || 'Sin departamento'
					if( !grupos[depto] ){
						grupos[depto] = {
							departamento: depto,
							personas: 0,
							minutos_ant: 0,
							minutos_act: 0,
							minutos_mas: 0,
							minutos_menos: 0,
							diferencia_minutos: 0,
						}
					}

					const minutosAnt = this.minutosDesdeHHMM(el.horas_ant)
					const minutosAct = this.minutosDesdeHHMM(el.horas_act)
					const diff = Number(el.diferencia_minutos) || (minutosAct - minutosAnt)

					grupos[depto].personas += 1
					grupos[depto].minutos_ant += minutosAnt
					grupos[depto].minutos_act += minutosAct
					grupos[depto].diferencia_minutos += diff
					if( diff > 0 ) grupos[depto].minutos_mas += diff
					if( diff < 0 ) grupos[depto].minutos_menos += Math.abs(diff)
				})

				return Object.values(grupos)
					.sort((a, b) => a.departamento.localeCompare(b.departamento, 'es'))
					.map(el => ({
						...el,
						horas_ant: this.formatoHorasDesdeMinutos(el.minutos_ant),
						horas_act: this.formatoHorasDesdeMinutos(el.minutos_act),
						horas_mas: el.minutos_mas ? this.formatoHorasDesdeMinutos(el.minutos_mas, true) : '00:00',
						horas_menos: el.minutos_menos ? ('-' + this.formatoHorasDesdeMinutos(el.minutos_menos)) : '00:00',
						diferencia: this.formatoHorasDesdeMinutos(el.diferencia_minutos, true),
					}))
			},

			kpiHorasTotal(){
				const depto = this.kpiHorasDepartamentos
				const minutos_ant = depto.reduce((sum, el) => sum + el.minutos_ant, 0)
				const minutos_act = depto.reduce((sum, el) => sum + el.minutos_act, 0)
				const diferencia_minutos = depto.reduce((sum, el) => sum + el.diferencia_minutos, 0)

				return {
					horas_ant: this.formatoHorasDesdeMinutos(minutos_ant),
					horas_act: this.formatoHorasDesdeMinutos(minutos_act),
					diferencia: this.formatoHorasDesdeMinutos(diferencia_minutos, true),
					diferencia_minutos,
				}
			},

			semanasCiclo(){
				return this.calcularSemanasCiclo(this.ciclo)
			},

			esSemana2(){
				return this.selectedHeaders == 2
			},

			headersComparativaBonosTabla(){
				if( this.esSemana2 ) return this.headersComparativaFinal2
				return this.headersComparativaFinal
			},
		},

		watch: {
			ciclo( value, oldValue ){
				if( !value || !this.selectedHeaders ) return
				const idActual = this.idCicloNomina()
				const idAnterior = oldValue
					? (typeof oldValue === 'object' ? oldValue.id_ciclo : oldValue)
					: null
				if( idAnterior && idActual !== idAnterior ){
					this.initialize()
					this.getLiberaNomina()
				}
			},
			selectedHeaders( value, oldValue ){
				if( !value || value === oldValue || !this.ciclo ) return
				this.initialize()
				this.getLiberaNomina()
			},
		},

		async created () {
			if( !this.asegurarAccesoNominaAdministrativa() ) return
			await this.getDepartamentos( )
			if( this.ciclo && this.selectedHeaders ){
				await this.initialize()
				await this.getLiberaNomina( )
			}
		},

		methods: {

			calcularSemanasCiclo( ciclo ){
				if( !ciclo || typeof ciclo !== 'object' ) return []
				if( !ciclo.fecha_inicio_ciclo || !ciclo.fecha_fin_ciclo ) return []

				const parseDate = ( fecha ) => new Date(fecha.substr(0, 10) + 'T12:00:00')
				const formatDate = ( fecha ) => fecha.toISOString().substr(0, 10)

				const inicio = parseDate(ciclo.fecha_inicio_ciclo)
				const fin = parseDate(ciclo.fecha_fin_ciclo)
				const semanas = []
				let current = new Date(inicio)
				let num = 1

				while( current <= fin ){
					const weekStart = new Date(current)
					const weekEnd = new Date(current)
					weekEnd.setDate(weekEnd.getDate() + 6)
					if( weekEnd > fin ) weekEnd.setTime(fin.getTime())

					semanas.push({
						bloque: `Semana ${ num }`,
						value: num,
						fecha_inicio: formatDate(weekStart),
						fecha_fin: formatDate(weekEnd),
					})

					num++
					current.setDate(current.getDate() + 7)
				}

				this.etiquetarSemanasCiclo( semanas )
				return semanas
			},

			etiquetarSemanasCiclo( semanas ){
				const total = semanas.length
				if( total < 5 ) return

				for( let i = 0; i < total; i++ ){
					const num = i + 1
					if( num === 1 ){
						semanas[i].bloque = 'Semana 1'
					} else if( num === 2 ){
						semanas[i].bloque = 'Semana 2'
					} else if( num === total - 1 ){
						semanas[i].bloque = 'Semana 3'
					} else if( num === total ){
						semanas[i].bloque = 'Semana 4'
					} else {
						semanas[i].bloque = `Semana vacaciones ${ num - 2 }`
					}
				}
			},

			getSemanaSeleccionada(){
				return this.semanasCiclo.find(el => el.value === this.selectedHeaders) || null
			},

			getFechaConsulta(){
				const semana = this.getSemanaSeleccionada()
				if( !semana ) return this.fecha

				if( semana.fecha_fin < this.fecha ) return semana.fecha_fin
				if( this.fecha >= semana.fecha_inicio && this.fecha <= semana.fecha_fin ) return this.fecha
				return semana.fecha_inicio
			},

			getSemanaAnteriorSeleccionada(){
				const contexto = this.getContextoSemanaAnterior()
				if( !contexto ) return null

				if( contexto.id_ciclo === this.idCicloNomina() ){
					return this.semanasCiclo.find(el => el.value === contexto.semana) || null
				}

				const ciclos = this.getCiclosDisponibles()
				const cicloAnterior = ciclos.find(el => el.id_ciclo === contexto.id_ciclo)
				if( !cicloAnterior ) return null

				const semanasAnterior = this.calcularSemanasCiclo(cicloAnterior)
				return semanasAnterior.find(el => el.value === contexto.semana) || semanasAnterior[semanasAnterior.length - 1] || null
			},

			parseFechaLocal( fecha ){
				return new Date(String(fecha).substr(0, 10) + 'T12:00:00')
			},

			formatFechaLocal( fecha ){
				return fecha.toISOString().substr(0, 10)
			},

			toSabado( fecha ){
				const d = this.parseFechaLocal(fecha)
				const menos = (d.getDay() + 1) % 7
				d.setDate(d.getDate() - menos)
				return d
			},

			toDomingo( fecha ){
				const d = this.parseFechaLocal(fecha)
				const mas = (7 - d.getDay()) % 7
				d.setDate(d.getDate() + mas)
				return d
			},

			diaAntes( fecha ){
				const d = this.parseFechaLocal(fecha)
				d.setDate(d.getDate() - 1)
				return this.formatFechaLocal(d)
			},

			rangoChecadorSemana( semana ){
				if( !semana || !semana.fecha_inicio || !semana.fecha_fin ) return null
				return {
					fecha_inicio: this.formatFechaLocal(this.toSabado(semana.fecha_inicio)),
					fecha_fin: this.formatFechaLocal(this.toDomingo(semana.fecha_fin)),
				}
			},

			formatoRangoHoras( rango ){
				if( !rango || !rango.fecha_inicio || !rango.fecha_fin ) return ''
				const a = String(rango.fecha_inicio).substr(0, 10).split('-')
				const b = String(rango.fecha_fin).substr(0, 10).split('-')
				if( a.length !== 3 || b.length !== 3 ) return ''
				return `${a[2]}/${a[1]}/${a[0]} a ${b[2]}/${b[1]}/${b[0]}`
			},

			getCiclosDisponibles(){
				return Array.isArray(this.ciclosLista) && this.ciclosLista.length ? this.ciclosLista : []
			},

			getContextoSemanaAnterior(){
				const idCicloActual = this.idCicloNomina()
				const semanaActual = this.selectedHeaders
				if( !idCicloActual || !semanaActual || !this.ciclo || typeof this.ciclo !== 'object' ) return null

				const semanas = this.semanasCiclo
				if( !semanas.length ) return null

				if( semanaActual > 1 ){
					const semanaAnterior = semanas.find(el => el.value === semanaActual - 1)
					if( !semanaAnterior ) return null
					return {
						id_ciclo: idCicloActual,
						semana: semanaActual - 1,
						fecha_consulta: semanaAnterior.fecha_fin,
					}
				}

				const ciclos = this.getCiclosDisponibles()
				const idx = ciclos.findIndex(el => el.id_ciclo === idCicloActual)
				const cicloAnterior = idx >= 0 && idx < ciclos.length - 1 ? ciclos[idx + 1] : null
				if( !cicloAnterior ) return null

				const semanasAnterior = this.calcularSemanasCiclo(cicloAnterior)
				if( !semanasAnterior.length ) return null
				const ultimaSemana = semanasAnterior[semanasAnterior.length - 1]

				return {
					id_ciclo: cicloAnterior.id_ciclo,
					semana: ultimaSemana.value,
					fecha_consulta: ultimaSemana.fecha_fin,
				}
			},

			getContextoBonosRiNiCicloAnterior(){
				if( !this.esSemana2 ) return null

				const idCicloActual = this.idCicloNomina()
				if( !idCicloActual ) return null

				const ciclos = this.getCiclosDisponibles()
				const idx = ciclos.findIndex(el => el.id_ciclo === idCicloActual)
				const cicloAnterior = idx >= 0 && idx < ciclos.length - 1 ? ciclos[idx + 1] : null
				if( !cicloAnterior ) return null

				const semana2 = this.calcularSemanasCiclo(cicloAnterior).find(el => el.value === 2)
				if( !semana2 ) return null

				return {
					id_ciclo: cicloAnterior.id_ciclo,
					semana: 2,
					fecha_consulta: semana2.fecha_fin,
				}
			},

			colorChipBonoAnterior( concepto ){
				if( this.esSemana2 && (concepto === 'Bonos RI' || concepto === 'Bonos NI') ) return 'red'
				return 'green'
			},

			async obtenerCompensacionesSemana( fecha ){
				if( !fecha ) return 0

				const response = await this.$http.post('rebajes_nomina.get.rebajes_nomina', { fecha })
				const rebajes = response.data || []

				return rebajes
					.filter(el => el.tipo_rebaje == 4)
					.reduce((sum, el) => sum + parseFloat(el.cantidad || 0), 0)
			},

			initialize () {
				const idCiclo = this.idCicloNomina()
				if( !idCiclo || !this.selectedHeaders ) return

				this.cargar = true
				this.nominaActual = []
				this.nominaActualBonos = []

				const payload = {
					fecha   : this.getFechaConsulta(),
					id_ciclo: idCiclo,
					semana  : this.selectedHeaders
				}

				return this.$http.post('usuarios.entradas', payload).then(async response=>{

					for( const i in response.data.result3 ){

						const { bonos_ventas, bonos_ri, bonos_puntualidad, prima_vacacional, compensaciones, bono_clases, monto_total_bonos, nombre_completo } = response.data.result3[i]

						let bono1           = bonos_ventas ? bonos_ventas.replace('$','').replace(',','')  : 0
						let bono2           = bonos_ri ? bonos_ri.replace('$','').replace(',','')  : 0
						let bono3           = bonos_puntualidad ? bonos_puntualidad.replace('$','').replace(',','') : 0
						let bonoPrima       = prima_vacacional ? String(prima_vacacional).replace('$','').replace(',','') : 0
						let bono4           = bono_clases ? bono_clases : 0

						let compensaciones2 = compensaciones ? compensaciones.replace('$','').replace(',','') : 0            

						response.data.result3[i].monto_total_bonos = this.format( parseFloat( compensaciones2 ) + parseFloat( bono1 ) + parseFloat( bono2 ) + parseFloat( bono3 ) + parseFloat( bonoPrima ) + parseFloat( bono4 ) )

					}

					if( this.getdatosUsuarioERPERP.iderp == 568 ){
						this.nominaActual      = response.data.result3.filter( el => el.departamento == 'OPERACIONES');
					}else{
						this.nominaActual      = response.data.result3;
					}

					this.nominaLiberada = !!response.data.liberada
					this.nominaActualBonos = response.data.result3;
					await this.nominaAnterior()
					this.compararSemanas( )
					await this.cargarComparativaHoras()

				}).catch( error =>{
					this.validarError( error.response.data.message )
				}).finally( () => { this.cargar = false })
			},

			getDepartamentos( ){

				this.departamentos = []

				this.$http.get('departamentos.all').then(response=>{
        
          this.departamentos = response.data // .filter( el => el.iddepartamento != 9) 
          
        }).catch( error =>{
					this.validarErrorDirecto( error.response.data.message )
				}).finally( () => { this.cargar = false })
			},

			async nominaAnterior () {
				this.cargar = true
				this.dataNominaAnterior = []
				this.compensacionesAct = 0
				this.compensacionesAnt = 0

				const anterior = this.getContextoSemanaAnterior()
				if( !anterior ){
					this.bonosRi = []
					this.bonosNI = []
					this.bonosPu = []
					this.bonosPrimaVac = []
					this.bonosClases = []
					this.cargar = false
					return
				}

				const payload = {
					fecha: anterior.fecha_consulta,
					id_ciclo: anterior.id_ciclo,
					semana: anterior.semana,
					id_ciclo_ant: anterior.id_ciclo,
					semana_bonos: anterior.semana,
				}

				try{
					const requests = [
						this.$http.post('usuarios.entradas.anterior', payload),
						this.obtenerCompensacionesSemana(this.getFechaConsulta()),
						this.obtenerCompensacionesSemana(anterior.fecha_consulta),
					]

					const contextoBonosRiNi = this.getContextoBonosRiNiCicloAnterior()
					if( contextoBonosRiNi ){
						requests.push(this.$http.post('usuarios.entradas.anterior', {
							fecha: contextoBonosRiNi.fecha_consulta,
							id_ciclo: contextoBonosRiNi.id_ciclo,
							semana: contextoBonosRiNi.semana,
							id_ciclo_ant: contextoBonosRiNi.id_ciclo,
							semana_bonos: contextoBonosRiNi.semana,
						}))
					}

					const results = await Promise.all(requests)
					const response = results[0]

					this.dataNominaAnterior = response.data.nominaAnterior
					this.compensacionesAct = results[1]
					this.compensacionesAnt = results[2]

					if( contextoBonosRiNi ){
						const responseBonosRiNi = results[3]
						this.bonosRi = responseBonosRiNi.data.bonosRi || []
						this.bonosNI = responseBonosRiNi.data.bonosNI || []
					}else{
						this.bonosRi = response.data.bonosRi || []
						this.bonosNI = response.data.bonosNI || []
					}

					this.bonosClases = []
				}catch( error ){
					let msg = 'Error al consultar nómina anterior'
					if( error && error.response && error.response.data && error.response.data.message ){
						msg = error.response.data.message
					}
					this.validarError( msg )
				}finally{
					this.cargar = false
				}
			},

			async cargarComparativaHoras(){
				this.cargandoHoras = true
				this.comparativaHoras = []
				this.rangosHoras = { actual: null, anterior: null }

				const semanaActual = this.getSemanaSeleccionada()
				const rangoActual = this.rangoChecadorSemana(semanaActual)
				if( !rangoActual ){
					this.cargandoHoras = false
					return
				}

				let rangoAnterior = this.rangoChecadorSemana(this.getSemanaAnteriorSeleccionada())
				if( rangoAnterior && rangoAnterior.fecha_fin >= rangoActual.fecha_inicio ){
					rangoAnterior = {
						fecha_inicio: rangoAnterior.fecha_inicio,
						fecha_fin: this.diaAntes(rangoActual.fecha_inicio),
					}
				}

				const payload = {
					fecha_inicio: rangoActual.fecha_inicio,
					fecha_fin: rangoActual.fecha_fin,
					fecha_inicio_ant: rangoAnterior ? rangoAnterior.fecha_inicio : null,
					fecha_fin_ant: rangoAnterior ? rangoAnterior.fecha_fin : null,
				}

				try{
					const response = await this.$http.post('usuarios.comparativa.horas', payload)
					this.comparativaHoras = response.data.comparativaHoras || []
					this.rangosHoras = {
						actual: rangoActual,
						anterior: rangoAnterior,
					}
				}catch( error ){
					let msg = 'Error al consultar comparativa de horas'
					if( error && error.response && error.response.data && error.response.data.message ){
						msg = error.response.data.message
					}
					this.validarError( msg )
				}finally{
					this.cargandoHoras = false
				}
			},

			colorDiferenciaHoras( minutos ){
				if( minutos > 0 ) return 'green--text font-weight-medium'
				if( minutos < 0 ) return 'red--text font-weight-medium'
				return ''
			},

			minutosDesdeHHMM( valor ){
				if( valor === null || valor === undefined || valor === '' ) return 0
				const match = String(valor).trim().match(/^([+-]?)(\d+):(\d{2})$/)
				if( !match ) return 0
				const mins = parseInt(match[2], 10) * 60 + parseInt(match[3], 10)
				return match[1] === '-' ? -mins : mins
			},

			formatoHorasDesdeMinutos( mins, conSigno ){
				const n = Number(mins) || 0
				const abs = Math.abs(Math.round(n))
				const texto = String(Math.floor(abs / 60)).padStart(2, '0') + ':' + String(abs % 60).padStart(2, '0')
				if( !conSigno || n === 0 ) return texto
				return (n > 0 ? '+' : '-') + texto
			},

			parseMonedaComparativa( valor ){
				if( valor === null || valor === undefined || valor === '' ) return 0
				if( typeof valor === 'number' ) return valor
				return parseFloat( String( valor ).replace(/[$,]/g, '') ) || 0
			},

			normalizarNombre( nombre ){
				return ( nombre || '' ).toString().trim().toUpperCase().replace( /\s+/g, ' ' )
			},

			// Marca la fila de Comparativa con id de la nómina actual para abrir el desglose.
			armarDesgloseComparativa( fuente ){
				if( !fuente || fuente.id == null ){
					return {
						tiene_desglose: false,
						desglose_id: null,
					}
				}

				return {
					tiene_desglose: true,
					desglose_id: fuente.id,
				}
			},

			abrirDesgloseComparativa( item ){
				if( !item || !item.tiene_desglose || item.desglose_id == null ) return

				const fuente = this.nominaActual.find( el => el.id == item.desglose_id )
				if( !fuente ){
					this.validarErrorDirecto( 'No se encontró el detalle de nómina de la semana actual para este colaborador.' )
					return
				}

				this.desgloseComparativa = this.construirDesgloseCompleto( fuente )
				this.dialogDesgloseComparativa = true
			},

			construirDesgloseCompleto( item ){
				const p = this.parseMonedaComparativa

				const laborado = p( item.monto_laborado )
				const extras = p( item.monto_horas_extras )
				const comisiones = p( item.comisiones_semana )
				const comisioness = p( item.comisioness )
				const comisionesExtra = ( comisioness && Math.abs( comisioness - comisiones ) > 0.009 ) ? comisioness : 0
				const premios = p( item.premios )

				const bonosVentas = p( item.bonos_ventas )
				const bonosRi = p( item.bonos_ri )
				const bonosPunt = p( item.bonos_puntualidad )
				const prima = p( item.prima_vacacional )
				const bonoClases = p( item.bono_clases )
				const compensaciones = p( item.compensaciones )

				const retardo = p( item.monto_retardo )
				const rebajesOtros = p( item.rebajes )
				const imss = p( item.seguroIMSS )
				const devoluciones = p( item.devoluciones )
				const caja = p( item.cajaAhorro )
				const retenciones = p( item.retensiones )
				const rebajesSuma = retardo + rebajesOtros + imss + devoluciones + caja + retenciones

				const tieneRebajesCampo = item.monto_total_rebajes !== undefined && item.monto_total_rebajes !== null && item.monto_total_rebajes !== ''
				const rebajesUsados = tieneRebajesCampo ? p( item.monto_total_rebajes ) : rebajesSuma

				const bonosAgregados = bonosVentas + bonosRi + bonosPunt + prima + bonoClases
				const sueldoSemanal = laborado + extras - rebajesUsados

				// Misma lógica del backend: compensaciones aparte de bonos (sin doble conteo).
				const totalCalc =
					laborado +
					extras +
					comisiones +
					comisionesExtra +
					premios +
					bonosAgregados +
					compensaciones -
					rebajesUsados

				const montoFinal = p( item.monto_total )
				const diferencia = Math.round( ( montoFinal - totalCalc ) * 100 ) / 100
				const cuadra = Math.abs( diferencia ) < 0.02

				const linea = ( label, valorNum, opts ) => {
					const opciones = opts || {}
					return {
						label: label,
						hint: opciones.hint || '',
						valorNum: valorNum,
						valor: opciones.texto != null ? opciones.texto : this.format( valorNum ),
						esSubtotal: !!opciones.esSubtotal,
						esTotal: !!opciones.esTotal,
						esDescuento: !!opciones.esDescuento,
					}
				}

				const sueldoMensual = p( item.sueldo_mensual ) || p( item.sueldo_mensual_sin_formato )
				const diasLaborados = item.dia_laboral != null ? item.dia_laboral : 0
				const diasExtra = item.cantidad_dias_extra != null ? item.cantidad_dias_extra : 0

				return {
					nombre: item.nombre_completo || '',
					puesto: item.puesto || '',
					plantel: item.plantel || '',
					secciones: [
						{
							titulo: '1. Jornada laboral',
							icon: 'mdi-briefcase-outline',
							color: 'primary',
							hint: 'Base semanal según días laborados',
							lineas: [
								linea( 'Sueldo mensual contratado', sueldoMensual, {
									hint: item.sueldo_semanal ? ( 'Semanal ref.: ' + item.sueldo_semanal ) : '',
								} ),
								linea( 'Sueldo día', p( item.sueldo_dia ) ),
								linea( 'Días laborados', Number( diasLaborados ) || 0, {
									texto: String( diasLaborados ),
									hint: item.sueldo_dia
										? ( this.format( p( item.sueldo_dia ) ) + ' × ' + diasLaborados + ' días' )
										: '',
								} ),
								linea( 'Monto jornada laboral', laborado, { esSubtotal: true } ),
							],
						},
						{
							titulo: '2. Horas extras',
							icon: 'mdi-clock-plus-outline',
							color: 'orange darken-1',
							hint: '',
							lineas: [
								linea( 'Sueldo hora', p( item.sueldo_hora ) ),
								linea( 'Horas extras', 0, {
									texto: item.cantidad_horas || '00:00',
									hint: item.cantidad_horas ? ( 'Cantidad registrada' ) : '',
								} ),
								linea( 'Días extra', Number( diasExtra ) || 0, {
									texto: String( diasExtra ),
									hint: diasExtra ? ( '× ' + this.format( p( item.sueldo_dia ) ) ) : '',
								} ),
								linea( 'Monto horas extras', extras, { esSubtotal: true } ),
							],
						},
						{
							titulo: '3. Comisiones por vendedor',
							icon: 'mdi-cash-multiple',
							color: 'teal darken-1',
							hint: '',
							lineas: comisionesExtra
								? [
									linea( 'Comisiones por vendedor / encargada', comisiones ),
									linea( 'Comisiones adicionales', comisionesExtra ),
									linea( 'Total comisiones', comisiones + comisionesExtra, { esSubtotal: true } ),
								]
								: [
									linea( 'Comisiones por vendedor / encargada', comisiones, { esSubtotal: true } ),
								],
						},
						{
							titulo: '4. Bonos agregados',
							icon: 'mdi-trophy-outline',
							color: 'amber darken-2',
							hint: 'Sin incluir compensaciones',
							lineas: [
								linea( 'Bonos ventas (NI)', bonosVentas, { hint: 'Mejor vendedora / NI' } ),
								linea( 'Bonos RI', bonosRi, { hint: 'Reinscripciones' } ),
								linea( 'Bonos puntualidad', bonosPunt, { hint: 'PYA' } ),
								linea( 'Prima vacacional', prima, { hint: 'Vacaciones aceptadas (jefe + RH)' } ),
								linea( 'Bono clases', bonoClases ),
								linea( 'Total bonos agregados', bonosAgregados, { esSubtotal: true } ),
							],
						},
						{
							titulo: '5. Compensaciones',
							icon: 'mdi-cash-plus',
							color: 'indigo darken-1',
							hint: '',
							lineas: premios
								? [
									linea( 'Compensaciones', compensaciones, {
										hint: 'Otros bonos / compensaciones',
									} ),
									linea( 'Premios', premios ),
									linea( 'Total compensaciones / premios', compensaciones + premios, { esSubtotal: true } ),
								]
								: [
									linea( 'Compensaciones', compensaciones, {
										esSubtotal: true,
										hint: 'Otros bonos / compensaciones',
									} ),
								],
						},
						{
							titulo: '6. Rebajes',
							icon: 'mdi-cash-minus',
							color: 'red darken-1',
							hint: 'Se restan del monto final',
							lineas: [
								linea( 'Retardos', retardo, { esDescuento: true } ),
								linea( 'Otros rebajes', rebajesOtros, { esDescuento: true } ),
								linea( 'Seguro IMSS', imss, { esDescuento: true } ),
								linea( 'Devoluciones', devoluciones, { esDescuento: true } ),
								linea( 'Caja de ahorro', caja, { esDescuento: true } ),
								linea( 'Retenciones', retenciones, { esDescuento: true } ),
								linea( 'Total rebajes', rebajesUsados, {
									esSubtotal: true,
									esDescuento: true,
									hint: Math.abs( rebajesSuma - rebajesUsados ) > 0.02
										? ( 'Suma conceptos: ' + this.format( rebajesSuma ) )
										: '',
								} ),
							],
						},
						{
							titulo: '7. Resumen y monto final',
							icon: 'mdi-sigma',
							color: 'success',
							hint: '(Jornada + Extras + Comisiones + Bonos + Compensaciones) − Rebajes',
							lineas: [
								linea( '(+) Jornada laboral', laborado ),
								linea( '(+) Horas extras', extras ),
								linea( '(+) Comisiones', comisiones + comisionesExtra ),
								linea( '(+) Bonos agregados', bonosAgregados ),
								linea( '(+) Compensaciones' + ( premios ? ' / premios' : '' ), compensaciones + premios ),
								linea( '(-) Rebajes', rebajesUsados, { esDescuento: true } ),
								linea( 'Sueldo semanal (jornada + extras − rebajes)', sueldoSemanal, { esSubtotal: true } ),
								linea( 'Monto calculado', totalCalc, { esSubtotal: true } ),
								linea( 'Monto final a recibir (sistema)', montoFinal, { esTotal: true } ),
							],
						},
					],
					totalCalc: totalCalc,
					montoFinal: montoFinal,
					diferencia: diferencia,
					diferenciaTexto: this.format( diferencia ),
					cuadra: cuadra,
				}
			},

			// Empareja un registro de la semana anterior con su registro actual.
			// Primero por id (caso normal) y, si el trabajador cambió de puesto
			// (su registro/id pudo cambiar), como respaldo por nombre completo.
			encontrarNominaActual( registro ){
				if( !registro ) return null

				const actualPorId = this.nominaActual.find( el => el.id == registro.id )
				if( actualPorId ) return actualPorId

				const nombre = this.normalizarNombre( registro.nombre_completo )
				if( !nombre ) return null

				return this.nominaActual.find( el => this.normalizarNombre( el.nombre_completo ) === nombre ) || null
			},

			compararSemanas( ){

				try{

					this.comparativaFinal = []
					this.comparativaFinalBonos = []
					this.comparativaFinalFinal = []
					// Semana actual
					// this.nominaActual
					
					// Semana anterior 
					// this.dataNominaAnterior
					// Sacar la comparativa del monto anterior vs el nuevo monto
					for( const i in this.dataNominaAnterior ){

						const { monto_laborado, monto_horas_extras,  monto_total_rebajes, monto_total_bonos, id, idsueldo_recepcion } = this.dataNominaAnterior[i]

						let monto_total_ant = monto_laborado + monto_horas_extras - monto_total_rebajes 

						this.dataNominaAnterior[i]['monto_total_ant'] = this.format( monto_total_ant )

						// Ver si existe un monto actual de esa persona por medio del id
						// (con respaldo por nombre si cambió de puesto)

						const existeNominaEmpleado = this.encontrarNominaActual( this.dataNominaAnterior[i] )

            if( id == 2187 ){ console.log( existeNominaEmpleado )}

						let monto_laborado2      = existeNominaEmpleado ? this.parseMonedaComparativa( existeNominaEmpleado.monto_laborado )      : 0
						let monto_horas_extras2  = existeNominaEmpleado ? this.parseMonedaComparativa( existeNominaEmpleado.monto_horas_extras )  : 0
						let monto_total_rebajes2 = existeNominaEmpleado ? this.parseMonedaComparativa( existeNominaEmpleado.monto_total_rebajes ) : 0
						let monto_total_bonos2   = existeNominaEmpleado ? this.parseMonedaComparativa( existeNominaEmpleado.monto_total_bonos )   : 0
						let idsueldo_recepcion2  = existeNominaEmpleado && existeNominaEmpleado.idsueldo_recepcion ? existeNominaEmpleado.idsueldo_recepcion : 0

						// Monto actual = jornada + extras - rebajes (desglose).
						// Si el desglose no viene (p.ej. cambio de puesto Recepción -> Encargada),
						// usamos el pago real: monto_total - comisiones - bonos (igual que en las altas).
						let monto_total_act = monto_laborado2 + monto_horas_extras2 - monto_total_rebajes2

						if( existeNominaEmpleado && monto_laborado2 === 0 ){
							let montoTotal2     = this.parseMonedaComparativa( existeNominaEmpleado.monto_total )
							let comisiones2     = this.parseMonedaComparativa( existeNominaEmpleado.comisiones_semana )
							let montoTotalReal  = montoTotal2 - comisiones2 - monto_total_bonos2

							if( montoTotalReal > 0 ) monto_total_act = montoTotalReal
						}

						this.dataNominaAnterior[i]['monto_total_act'] = this.format( monto_total_act )

						if( existeNominaEmpleado ){
							this.dataNominaAnterior[i]['puesto']  = existeNominaEmpleado.puesto  || this.dataNominaAnterior[i]['puesto']
							this.dataNominaAnterior[i]['plantel'] = existeNominaEmpleado.plantel || this.dataNominaAnterior[i]['plantel']
						}


						this.dataNominaAnterior[i]['diferencia'] = this.format( monto_total_act - monto_total_ant )

						// Agregar los motivos

						let motivo = ''

						if( this.parseMonedaComparativa( monto_laborado ) != monto_laborado2 ){
							motivo += ' Diferencia en el total de días laborados'
						}

						if( this.parseMonedaComparativa( monto_horas_extras ) != monto_horas_extras2 ){
							motivo += ' , Diferencia en horas extra'
						}

						if( this.parseMonedaComparativa( monto_total_rebajes ) != monto_total_rebajes2 ){
							motivo += ' , Diferencia en los rebajes'
						}

						if( this.parseMonedaComparativa( monto_total_bonos ) != monto_total_bonos2 ){
							motivo += ' , Diferencia en los bonos'
						}


						if( idsueldo_recepcion != idsueldo_recepcion2 ){
							motivo += ' , Diferencia en sueldo'
						}

						this.dataNominaAnterior[i]['motivo'] = motivo

						Object.assign( this.dataNominaAnterior[i], this.armarDesgloseComparativa( existeNominaEmpleado ) )
					}

					// Sacamos los nuevos (no emparejados ni por id ni por nombre)
					let nuevosEmpleados = this.nominaActual.filter( el => {
						return !this.dataNominaAnterior.some( ant => {
							const actual = this.encontrarNominaActual( ant )
							return actual && actual.id == el.id
						})
					})

					// Ahora separamos todo por departamento
					for( const i in this.departamentos ){

						const { iddepartamento } = this.departamentos[i]

						this.departamentos[i]['nomina'] = this.dataNominaAnterior.filter( el => el.iddepartamento == iddepartamento)

						let nuevosEmpleadosPuesto = nuevosEmpleados.filter( el => el.iddepartamento == iddepartamento)


						for(const j in nuevosEmpleadosPuesto ){

							
							let comisiones_semana = nuevosEmpleadosPuesto[j].comisiones_semana ? nuevosEmpleadosPuesto[j].comisiones_semana.replace('$','').replace(',','') : 0
							let montoTotal        = nuevosEmpleadosPuesto[j].monto_total       ? nuevosEmpleadosPuesto[j].monto_total.replace('$','').replace(',','') : 0

              let montoBonoLimpio = parseFloat( nuevosEmpleadosPuesto[j].monto_total_bonos.replace('$','').replace(',','') )
							let monto_final = parseFloat( montoTotal  - comisiones_semana )
							let monoBono    = parseFloat( montoBonoLimpio )
              
							// Agregar a los nuevos
							this.departamentos[i].nomina.push(Object.assign({
								nombre_completo: nuevosEmpleadosPuesto[j].nombre_completo,
								puesto         : nuevosEmpleadosPuesto[j].puesto,
								plantel        : nuevosEmpleadosPuesto[j].plantel,
								monto_total_ant: this.format( 0 ),
								monto_total_act: this.format( monto_final - monoBono ),
								diferencia     : this.format( monto_final - monoBono ),
								motivo         : 'ALTA'
							}, this.armarDesgloseComparativa( nuevosEmpleadosPuesto[j] )))
						}
					}

					let totalAnterior2  = 0
					let totalActual2 = 0
					let diferenciaTotal2 = 0

					// Sacar los totales
					let nominaActualLideres = 0
					let nominaAnteriorLideres = 0

					// Sacar los totales solo para COORDINADOR ACADEMICO
					for( const i in this.departamentos ){

						const { nomina } = this.departamentos[i]

						let totalAnterior = nomina.filter( el => el.puesto == 'COORDINADOR ACADEMICO' ).map(item => parseFloat( item.monto_total_ant.replace(',','').replace('$','') ) ).reduce((prev, curr) => prev + curr, 0)
						
						nominaAnteriorLideres += totalAnterior

						let totalActual   = nomina.filter( el => el.puesto == 'COORDINADOR ACADEMICO' ).map(item => parseFloat( item.monto_total_act.replace(',','').replace('$','') ) ).reduce((prev, curr) => prev + curr, 0)

						nominaActualLideres += totalActual

						if( totalAnterior || totalActual ){
							this.departamentos[i].nomina.push({
								nombre_completo: 'Nomina COORDINADOR ACADEMICO' ,
								puesto         : '',
								plantel        : '',
								monto_total_ant: this.format( totalAnterior ),
								monto_total_act: this.format( totalActual ),
								diferencia     : this.format( totalActual - totalAnterior ),
								motivo         : ''
							})
						}
					}

					for( const i in this.departamentos ){

						const { nomina, departamento } = this.departamentos[i]

						let totalAnterior3 = nomina.filter( el => el.puesto != 'COORDINADOR ACADEMICO' && el.puesto ).map(item => parseFloat( item.monto_total_ant.replace(',','').replace('$','') ) ).reduce((prev, curr) => prev + curr, 0)

						totalAnterior2 += totalAnterior3

						let totalActual3   = nomina.filter( el => el.puesto != 'COORDINADOR ACADEMICO' && el.puesto ).map(item => parseFloat( item.monto_total_act.replace(',','').replace('$','') ) ).reduce((prev, curr) => prev + curr, 0)


						totalActual2 += totalActual3

						diferenciaTotal2 += totalActual3 - totalAnterior3

						this.departamentos[i].nomina.push({
							nombre_completo: departamento == 'OPERACIONES' ? 'Nomina Operación ( Recep, Enc, Vent, Limp, Mto, Aux., Prog Product, coord. )' : `Nomina ${departamento}` ,
							puesto         : '',
							plantel        : '',
							monto_total_ant: this.format( totalAnterior3 ),
							monto_total_act: departamento == 'OPERACIONES' ? this.format( totalActual3 - 0 ) : this.format( totalActual3 ),
							diferencia     : departamento == 'OPERACIONES' ? this.format( totalActual3  - totalAnterior3 ) : this.format( totalActual3 - totalAnterior3 ),
							motivo         : ''
						})

						this.comparativaFinal.push({
							Concepto       : departamento == 'OPERACIONES' ? 'Nomina Operación ( Recep, Enc, Vent, Limp, Mto, Aux., Prog Product, coord., Teach )' : `Nomina ${departamento}` ,
							monto_total_ant: departamento == 'OPERACIONES' ? this.format( totalAnterior3 + nominaAnteriorLideres ) : this.format( totalAnterior3  ),
							monto_total_act: departamento == 'OPERACIONES' ? this.format( totalActual3 - 0 + nominaActualLideres ) : this.format( totalActual3  ),
							diferencia     : departamento == 'OPERACIONES' ? this.format( totalActual3 - 0 - totalAnterior3 + nominaActualLideres - nominaAnteriorLideres )	 : 	this.format( totalActual3 - totalAnterior3 )	
						})

					}



					// Sacar los totales solo para COORDINADOR ACADEMICO
					for( const i in this.departamentos ){

						const { nomina, departamento } = this.departamentos[i]

						if( departamento == "OPERACIONES" ){

							let nominas = nomina.filter( el => el.nombre_completo.match('Nomina') )

							let nomninaActual     = nominas.map(item => parseFloat( item.monto_total_act.replace(',','').replace('$','') ) ).reduce((prev, curr) => prev + curr, 0)
							let nomninaAnterios   = nominas.map(item => parseFloat( item.monto_total_ant.replace(',','').replace('$','') ) ).reduce((prev, curr) => prev + curr, 0)
							let nomninaDiferencia = nominas.map(item => parseFloat( item.diferencia.replace(',','').replace('$','') ) ).reduce((prev, curr) => prev + curr, 0)

							this.departamentos[i].nomina.push({
								nombre_completo: 'Nomina Total Operativa' ,
								puesto         : '',
								plantel        : '',
								monto_total_ant: this.format( nomninaAnterios ),
								monto_total_act: this.format( nomninaActual - 0 ),
								diferencia     : this.format( nomninaActual - nomninaAnterios ),
								motivo         : ''
							})
						}
					}


					this.totalAnterior    = this.format( totalAnterior2 )
 					this.totalActual      = this.format( totalActual2 )
					this.diferenciaTotal	= this.format( totalActual2 - totalAnterior2 )			

					

					// COMPARAR LAS COMISIONESSSS
					// monto_total_ant_comisiones
					// monto_total_act_comisiones
					// diferencia_comisiones

					let comsionesAnt = 0
					let comicionesAct = 0
					let comisionesDif = 0

					this.comparativaComisiones = this.dataNominaAnterior.filter( el => el.comisiones_semana )
					// Sacamos los nuevos
					let comsionesAnteriores = this.comparativaComisiones.map((registro) => { return registro.id })

					let nuevasComisiones    = this.nominaActual.filter( el => !comsionesAnteriores.includes( el.id ) && el.comisiones_semana )

					for( const i in this.comparativaComisiones ){

						const { comisiones_semana, id } = this.comparativaComisiones[i]

						const existenComisiones = this.encontrarNominaActual( this.comparativaComisiones[i] )

						let monto_total_act_comisiones = existenComisiones && existenComisiones.comisiones_semana ? existenComisiones.comisiones_semana : '$0.00'

						let diferencia_comisiones =  parseFloat(monto_total_act_comisiones.replace(',','').replace('$','') ) - comisiones_semana

						comsionesAnt  += comisiones_semana
						comicionesAct += parseFloat(monto_total_act_comisiones.replace(',','').replace('$','') )
						comisionesDif += diferencia_comisiones

						this.comparativaComisiones[i]['monto_total_ant_comisiones'] = this.format( comisiones_semana )

						this.comparativaComisiones[i]['diferencia_comisiones']      = this.format( diferencia_comisiones )

						this.comparativaComisiones[i]['monto_total_act_comisiones'] = this.format( monto_total_act_comisiones )
					}

					for( const i in nuevasComisiones ){

						const { comisiones_semana, id, nombre_completo } = nuevasComisiones[i]

						let comisionesActNuevas = parseFloat(comisiones_semana.replace(',','').replace('$','') )

						comicionesAct += comisionesActNuevas

						this.comparativaComisiones.push({
							nombre_completo,
							puesto: 'ENCARGADA DE SUCURSAL',
							plantel:'SIN PLANTEL',
							monto_total_ant_comisiones: '$0.00',
							diferencia_comisiones     : this.format( comisionesActNuevas ),
							monto_total_act_comisiones: this.format( comisionesActNuevas )
						})

					}

					this.comparativaComisiones.push({
						nombre_completo            : 'TOTAL',
						puesto                     : '',
						plantel                    : 'TODOS',
						monto_total_ant_comisiones : this.format( comsionesAnt ),
						monto_total_act_comisiones : this.format( comicionesAct ),
						diferencia_comisiones      : this.format( comicionesAct - comsionesAnt )
					})

					this.comparativaFinal.push({
						Concepto       : 'TOTAL DE NOMINA',
						monto_total_ant: this.format( totalAnterior2 + nominaAnteriorLideres ),
						monto_total_act: this.format( totalActual2 + nominaActualLideres),
						diferencia     : this.format( (totalActual2  ) - ( totalAnterior2 ) + ( nominaActualLideres - nominaAnteriorLideres ) )			
					})

					let bonosRI = this.nominaActualBonos.filter( el => el.bonos_ri ) 
					// let bonosClases = this.nominaActualBonos.filter( el => el.bono_clases ) 

					// Sacamos los nuevos
					let bonoRIAnte     = this.bonosRi.map((registro) => { return registro.id })

					let nuevosBonosRI  = bonosRI.filter( el => !bonoRIAnte.includes( el.id ) )


					// For para los bonos de RI 
					// bonosRi

					let bonoRIAnt = 0
					let bonoRIAct = 0
					let bonoRIDif = 0

					for( const i in this.bonosRi ){

						let { bono_ri, id } = this.bonosRi[i]

						let existeBonoRi = bonosRI.find( el => el.id == id ) 

						let monto_total_act = existeBonoRi ? existeBonoRi.bonos_ri : 0

						let diferencia = bono_ri - monto_total_act

						bonoRIAct += parseFloat( monto_total_act )
						bonoRIAnt += parseFloat( bono_ri )
						bonoRIDif += parseFloat( diferencia )

						this.bonosRi[i]['monto_total_act'] = this.format( monto_total_act )
						
						this.bonosRi[i]['diferencia'] = this.format( diferencia )

						this.bonosRi[i].bono_ri = this.format( bono_ri )

					}

					// Agregamos los nuevos BONOSSSS
					for( const i in nuevosBonosRI ){

						const { nombre_completo, id, puesto, plantel, bonos_ri } = nuevosBonosRI[i]

						bonoRIAnt += 0
						bonoRIAct += parseFloat( bonos_ri )
						bonoRIDif += parseFloat( bonos_ri )

						this.bonosRi.push({
							nombre_completo,
							puesto,
							plantel,
							bono_ri: 0,
							monto_total_act: this.format( bonos_ri ),
							diferencia: this.format( bonos_ri )
						})

					}


					let totalRI = this.bonosRi.map(item => parseFloat( item.monto_total_act.replace(',','').replace('$','') )).reduce((prev, curr) => prev + curr, 0)
					// let totalRIAnt = this.bonosRi.map(item => parseFloat( item.bono_ri.replace(',','').replace('$','') )).reduce((prev, curr) => prev + curr, 0)

					this.bonosRi.push({
						nombre_completo    : 'TOTAL',
						puesto             : '',
						plantel            : 'TODOS',
						bono_ri            : this.format( bonoRIAnt ),
						monto_total_act    : this.format( totalRI ),
						diferencia         : this.format( totalRI - bonoRIAnt )
					})

				  //bonoRIAnt = 0
          
					this.comparativaFinalBonos.push({
						Concepto       : 'Bonos RI',
						monto_total_ant: this.format( bonoRIAnt ),
						monto_total_act: this.format( totalRI ),
						diferencia     : this.format( totalRI - bonoRIAnt )		,	
						diferenciareal : this.format( totalRI )			
					})

					let bonoClasesAnt = 0
          let totalClases = this.nominaActualBonos.filter( el => el.bono_clases ).map( item => parseFloat( item.bono_clases ) ).reduce((prev, curr) => prev + curr, 0)

          this.comparativaFinalBonos.push({
						Concepto       : 'Bonos Coordinación',
						monto_total_ant: this.format( 0 ),
						monto_total_act: this.format( totalClases ),
						diferencia     : this.format( totalClases - bonoClasesAnt )		,	
						diferenciareal : this.format( totalClases )			
					})


					let bonoNI = this.nominaActualBonos.filter( el => el.bonos_ventas ) 

					// Sacamos los nuevos
					let bonoNIAnte     = this.bonosNI.map((registro) => { return registro.id })

					let nuevosBonosNI  = bonoNI.filter( el => !bonoNIAnte.includes( el.id ) )

					let bonoNIAnt = 0
					let bonoNIAct = 0
					let bonoNIDif = 0

					// bonosNI
					for( const i in this.bonosNI ){

						let { bono_ni, id } = this.bonosNI[i]

						let existeBonoNi = bonoNI.find( el => el.id == id ) 

						let monto_total_act = existeBonoNi ? parseFloat(existeBonoNi.bonos_ventas.replace('$','').replace(',','')) : 0

						let diferencia = bono_ni - monto_total_act

						bonoNIAnt+= parseFloat( bono_ni )
						bonoNIAct+= parseFloat( monto_total_act )
						bonoNIDif+= parseFloat( diferencia )

						this.bonosNI[i]['monto_total_act'] = this.format( monto_total_act )
						// this.bonosNI[i]['bono_ni']         = this.format( monto_total_act )
						
						this.bonosNI[i]['diferencia'] = this.format( diferencia )

						this.bonosNI[i].bono_ni = this.format( bono_ni )

					}

					// Agregamos los nuevos BONOSSSS
					for( const i in nuevosBonosNI ){

						const { nombre_completo, id, puesto, plantel, bonos_ventas } = nuevosBonosNI[i]

						bonoNIAnt+= 0
						bonoNIAct+= parseFloat(bonos_ventas.replace('$','').replace(',',''))
						bonoNIDif+= parseFloat(bonos_ventas.replace('$','').replace(',',''))

						this.bonosNI.push({
							nombre_completo,
							puesto,
							plantel,
							bono_ni: this.format( 0 ),
							monto_total_act: this.format( bonos_ventas ),
							diferencia: this.format( bonos_ventas )
						})

					}


					this.bonosNI.push({
						nombre_completo  : 'TOTAL',
						puesto           : '',
						plantel          : 'TODOS',
						bono_ni          : this.format( bonoNIAnt ),
						monto_total_act  : this.format( bonoNIAct ),
						diferencia       : this.format( bonoNIAct - bonoNIAnt )
					})


					/***************************************************/
					/*             BONOS DE PUNTUALIDAD                */

					// Clonamos para no mutar los objetos de dataNominaAnterior:
					// este loop reescribe monto_total_act y, al compartir referencias,
					// borraba el monto de la tabla principal (p.ej. encargadas con puntualidad).
					this.bonosPu = this.dataNominaAnterior.filter( el => el.puntualidad ).map( el => ({ ...el }) )

					let bonoPuAnteriores = this.bonosPu.map((registro) => { return registro.id })

					let nuevosBonosPu = this.nominaActual.filter(
						el => !bonoPuAnteriores.includes( el.id ) && el.bonos_puntualidad
					)

					let bonoPuAnt = 0
					let bonoPuAct = 0
					let bonoPuDif = 0

					for( const i in this.bonosPu ){

						const { puntualidad, id } = this.bonosPu[i]

						const existeBonoPu = this.encontrarNominaActual( this.bonosPu[i] )

						let monto_total_act = existeBonoPu && existeBonoPu.bonos_puntualidad
							? parseFloat(existeBonoPu.bonos_puntualidad.replace('$','').replace(',',''))
							: 0

						let puntualidadAnt = parseFloat(puntualidad || 0)
						let diferencia = monto_total_act - puntualidadAnt

						bonoPuAnt += puntualidadAnt
						bonoPuAct += monto_total_act
						bonoPuDif += diferencia

						this.bonosPu[i]['monto_total_act'] = this.format( monto_total_act )
						this.bonosPu[i]['diferencia'] = this.format( diferencia )
						this.bonosPu[i]['puntualidad'] = this.format( puntualidadAnt )
					}

					for( const i in nuevosBonosPu ){

						const { nombre_completo, id, puesto, plantel, bonos_puntualidad } = nuevosBonosPu[i]

						let bonoPuntualidadAct = parseFloat(bonos_puntualidad.replace('$','').replace(',',''))

						bonoPuAct += bonoPuntualidadAct
						bonoPuDif += bonoPuntualidadAct

						this.bonosPu.push({
							nombre_completo,
							puesto,
							plantel,
							puntualidad: this.format( 0 ),
							monto_total_act: this.format( bonoPuntualidadAct ),
							diferencia: this.format( bonoPuntualidadAct )
						})
					}

					this.bonosPu.push({
						nombre_completo  : 'TOTAL',
						puesto           : '',
						plantel          : 'TODOS',
						puntualidad      : this.format( bonoPuAnt ),
						monto_total_act  : this.format( bonoPuAct ),
						diferencia       : this.format( bonoPuAct - bonoPuAnt )
					})

					/***************************************************/
					/*             PRIMA VACACIONAL                    */

					const parseMontoLocal = (val) => {
						if (val == null || val === '') return 0
						return parseFloat(String(val).replace('$','').replace(',','')) || 0
					}

					this.bonosPrimaVac = this.dataNominaAnterior
						.filter( el => el.prima_vacacional )
						.map( el => ({ ...el }) )

					let primaVacAnteriores = this.bonosPrimaVac.map((registro) => { return registro.id })

					let nuevosPrimaVac = this.nominaActual.filter(
						el => !primaVacAnteriores.includes( el.id ) && el.prima_vacacional
					)

					let primaVacAnt = 0
					let primaVacAct = 0

					for( const i in this.bonosPrimaVac ){

						const { prima_vacacional, id } = this.bonosPrimaVac[i]

						const existePrima = this.encontrarNominaActual( this.bonosPrimaVac[i] )

						let monto_total_act = existePrima && existePrima.prima_vacacional
							? parseMontoLocal(existePrima.prima_vacacional)
							: 0

						let primaAnt = parseMontoLocal(prima_vacacional)
						let diferencia = monto_total_act - primaAnt

						primaVacAnt += primaAnt
						primaVacAct += monto_total_act

						this.bonosPrimaVac[i]['monto_total_act'] = this.format( monto_total_act )
						this.bonosPrimaVac[i]['diferencia'] = this.format( diferencia )
						this.bonosPrimaVac[i]['prima_vacacional'] = this.format( primaAnt )
					}

					for( const i in nuevosPrimaVac ){

						const { nombre_completo, id, puesto, plantel, prima_vacacional } = nuevosPrimaVac[i]

						let primaAct = parseMontoLocal(prima_vacacional)

						primaVacAct += primaAct

						this.bonosPrimaVac.push({
							nombre_completo,
							puesto,
							plantel,
							id,
							prima_vacacional: this.format( 0 ),
							monto_total_act: this.format( primaAct ),
							diferencia: this.format( primaAct )
						})
					}

					this.bonosPrimaVac.push({
						nombre_completo  : 'TOTAL',
						puesto           : '',
						plantel          : 'TODOS',
						prima_vacacional : this.format( primaVacAnt ),
						monto_total_act  : this.format( primaVacAct ),
						diferencia       : this.format( primaVacAct - primaVacAnt )
					})

					/******************************************************/
					// if( this.selectedHeaders != 2 ){
						// bonoRIAnt = 0
						 // bonoNIAnt = 0
						// bonoPuAnt = 0
					// }

					this.comparativaFinalBonos.push({
						Concepto       : 'Comisiones',
						monto_total_ant: this.format( comsionesAnt ),
						monto_total_act: this.format( comicionesAct ),
						diferencia     : this.format( comicionesAct - comsionesAnt )	,		
						diferenciareal     : this.format( comicionesAct - comsionesAnt )	,		
					})

					this.comparativaFinalBonos.push({
						Concepto       : 'Bonos NI',
						monto_total_ant: this.format( bonoNIAnt ),
						monto_total_act: this.format( bonoNIAct ),
						diferencia     : this.format( bonoNIAct - bonoNIAnt )	,		
						diferenciareal : this.format( bonoNIAct )			
					})

					this.comparativaFinalBonos.push({
						Concepto       : 'Bonos Puntualidad',
						monto_total_ant: this.format( bonoPuAnt ),
						monto_total_act: this.format( bonoPuAct ),
						diferencia     : this.format( bonoPuAct - bonoPuAnt )	,		
						diferenciareal : this.format( bonoPuAct )			
					})

					this.comparativaFinalBonos.push({
						Concepto       : 'Prima Vacacional',
						monto_total_ant: this.format( primaVacAnt ),
						monto_total_act: this.format( primaVacAct ),
						diferencia     : this.format( primaVacAct - primaVacAnt ),
						diferenciareal : this.format( primaVacAct )
					})

					let compensacionesAct = this.compensacionesAct
					let compensacionesAnt = this.compensacionesAnt


					this.comparativaFinalBonos.push({
						Concepto       : 'Compensaciones',
						monto_total_ant: this.format( compensacionesAnt ),
						monto_total_act: this.format( compensacionesAct ),
						diferencia     : this.format( compensacionesAct - compensacionesAnt )		,	
						diferenciareal     : this.format( compensacionesAct - compensacionesAnt )	,		
					})

					
					this.comparativaFinalBonos.push({
						Concepto       : 'TOTAL BONOS Y COMISIONES',
						monto_total_ant: this.format( bonoRIAnt + bonoNIAnt + bonoPuAnt + primaVacAnt + comsionesAnt + compensacionesAnt + bonoClasesAnt ),
						monto_total_act: this.format( totalRI + bonoNIAct + bonoPuAct + primaVacAct + comicionesAct + compensacionesAct + totalClases ),
						diferencia     : this.format( totalRI - bonoRIAnt + bonoNIAct - bonoNIAnt + bonoPuAct - bonoPuAnt + primaVacAct - primaVacAnt + comicionesAct - comsionesAnt  + compensacionesAct - compensacionesAnt + totalClases - bonoClasesAnt )		,	
						diferenciareal : this.format( totalRI + bonoNIAct + bonoPuAct + primaVacAct + comicionesAct - comsionesAnt  + compensacionesAct - compensacionesAnt + totalClases - bonoClasesAnt )			

					})

					let riAntTotalPagar = this.esSemana2 ? 0 : bonoRIAnt
					let niAntTotalPagar = this.esSemana2 ? 0 : bonoNIAnt

					this.comparativaFinalFinal.push({
						Concepto       : 'TOTAL A PAGAR',
						monto_total_ant: this.format( totalAnterior2 + nominaAnteriorLideres + riAntTotalPagar + niAntTotalPagar + bonoPuAnt + primaVacAnt + comsionesAnt + compensacionesAnt + bonoClasesAnt),
						monto_total_act: this.format( totalActual2 - 0  + nominaActualLideres + totalRI + bonoNIAct + bonoPuAct + primaVacAct + comicionesAct + compensacionesAct + totalClases ),
						diferencia     : this.format( (totalActual2 - 0 ) - ( totalAnterior2 ) + ( nominaActualLideres - nominaAnteriorLideres ) + ( totalRI - riAntTotalPagar + bonoNIAct - niAntTotalPagar + bonoPuAct - bonoPuAnt + primaVacAct - primaVacAnt + comicionesAct - comsionesAnt + totalClases - bonoClasesAnt )  + ( compensacionesAct - compensacionesAnt )),
						diferenciareal     : this.format( (totalActual2 - 0 ) - ( totalAnterior2 ) + ( nominaActualLideres - nominaAnteriorLideres ) + ( totalRI - riAntTotalPagar + bonoNIAct - niAntTotalPagar + bonoPuAct - bonoPuAnt + primaVacAct - primaVacAnt + comicionesAct - comsionesAnt + totalClases - bonoClasesAnt )  + ( compensacionesAct - compensacionesAnt + totalClases - bonoClasesAnt ))			
					})


					// this.nominaActual

				}catch( error ){
					this.validarErrorDirecto( error.message ) 
				}
			},

			getNominaSemanal () {
				this.cargar = true

				const payload = {
					fecha:    this.fecha,   
				}

				return this.$http.post('encargadas_comisiones.get.nominasemanal', payload).then(response=>{
					this.nominaSemanal = response.data;
					this.cargar      = false  
				}).catch( error =>{
					this.validarError( error.response.data.message )
				}).finally( () => { this.cargar = false })
			},

			subirNomina () {
				this.cargar = true


				var baseRequi = {
      		registro:                      null,
      		id_usuario_solicita:           this.getdatosUsuarioERPERP.iderp,
		      id_sucursal_solicita:          this.getdatosUsuarioERPERP.id_plantel,
		      id_requisicion_compra_estatus: 1,
		      id_usuario_ultimo_cambio:      this.getdatosUsuarioERPERP.iderp,
		      id_usuario_compra:             28,
		      tipo_requisicion:              1,
		      ciclo:                         this.ciclo,
          id_proyecto:                   null,
		      comentarios:                   'Nómina',
			    fotos:[]
	      }

				const payload = {
					fecha               : this.fecha,  
					data                : this.filterEntradas,
					id_ciclo            : this.ciclo,
					semana              : this.selectedHeaders,
					requiOperativaInbi  : this.generaRequiOperativaInbi( this.nominaActual ),
					requiOperativaFast  : this.generaRequiOperativaFast( this.nominaActual ),
					requiComisionesInbi : this.generaRequiComisionesInbi( this.nominaActual ),
					requiComisionesFast : this.generaRequiComisionesFast( this.nominaActual ),
					requiBonosInbi      : this.generaRequiBonosInbi( this.nominaActual ),
					requiBonostivaFast  : this.generaRequiBonosFast( this.nominaActual ),
					baseRequi
				}

				this.$http.post('encargadas_comisiones.add.historialnomina', payload).then(response=>{

					this.historialNomina = response.data

					this.validarSuccess('Datos grabados correctamente')
					this.dialogAceptar = false
					this.initialize();

					this.cargar = false

				}).catch( error =>{
					this.validarError( error.response.data.message )
				}).finally( () => { this.cargar = false })	
			},

			verComentarios( value ){

				this.renglonNomina = value

				this.dialogComentarios = true
			},

			s2ab(s) {
				var buf = new ArrayBuffer(s.length);
				var view = new Uint8Array(buf);
				for (var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
					return buf;
			},

			exportar(){
				let data = XLSX.utils.json_to_sheet(this.nominaActual)

				const workbook = XLSX.utils.book_new()
				const filename = 'entradas_salidas'
				XLSX.utils.book_append_sheet(workbook, data, filename)

				var wbout = XLSX.write(workbook, {
					bookType: 'xls',
					bookSST: false,
					type: 'binary'
				});

				const file = new File([new Blob([this.s2ab(wbout)])], filename + '.xls')

				let formData = new FormData();
		        // //se crea el objeto y se le agrega como un apendice el archivo 
				formData.append('file',file);
		        // /*getDatosRiesgo the form data*/

				this.$http.post('pdfs',formData).then(response=> {
					window.location = axios.defaults.baseURL + 'pdfs/' + filename + '.xls'
				}).catch(error=> {
					console.log(error);
				});
			},

			formulaMontoLaborado(item) {
				let sueldo_dia = item.sueldo_dia;
				let dia_laboral = item.dia_laboral;
				this.formula_monto_laborado = `$${sueldo_dia}  X  ${dia_laboral} dias`;
			},   

			formulaMontoHorasExtras(item) {
				let sueldo_hora = item.sueldo_hora;
				let cantidad_horas = item.cantidad_horas;
				this.formula_horas_extras = `${sueldo_hora}  X  ${cantidad_horas} horas extras`;
			},  

			formulaMontoRebajes(item) {
				let rebajes = item.rebajes !== undefined && item.rebajes !== null ? item.rebajes : 0.00;
				let seguroIMSS = item.seguroIMSS !== undefined && item.seguroIMSS !== null ? item.seguroIMSS : 0.00;
				let cajaAhorro = item.cajaAhorro !== undefined && item.cajaAhorro !== null ? item.cajaAhorro : 0.00;
				let monto_retardo = item.monto_retardo !== undefined && item.monto_retardo !== null ? item.monto_retardo : 0.00;
				let retensiones = item.retensiones !== undefined && item.retensiones !== null ? item.retensiones : 0.00;
				let devoluciones = item.devoluciones !== undefined && item.devoluciones !== null ? item.devoluciones : 0.00;

				this.formula_monto_rebajes = `
				Monto Retardo: $${monto_retardo}\n  
				Monto Otros: $${rebajes}\n  
				Monto Seguro IMSS: $${seguroIMSS}\n  
				Monto Devoluciones: $${devoluciones}\n  
				Monto Caja Ahorro: $${cajaAhorro}\n  
				Monto Retenciones: $${retensiones}
				`;
			},

			formulaMontoBonos(item) {
				let bonos_ventas = item.bonos_ventas !== undefined && item.bonos_ventas !== null ? item.bonos_ventas : 0.00;
				let bonos_ri = item.bonos_ri !== undefined && item.bonos_ri !== null ? item.bonos_ri : 0.00;
				let bonos_puntualidad = item.bonos_puntualidad !== undefined && item.bonos_puntualidad !== null ? item.bonos_puntualidad : 0.00;
				let prima_vacacional = item.prima_vacacional !== undefined && item.prima_vacacional !== null ? item.prima_vacacional : 0.00;

				this.formula_monto_bonos = `
				Monto Bonos Ventas: $${bonos_ventas}\n  
				Monto Bonos RI: $${bonos_ri}\n  
				Monto Bonos Puntualidad: $${bonos_puntualidad}\n  
				Prima Vacacional: $${prima_vacacional}
				`;
			},

			formulaMontoTotal(item) {
				let monto_laborado = item.monto_laborado !== undefined && item.monto_laborado !== null ? item.monto_laborado : 0.00;
				let compensaciones = item.compensaciones !== undefined && item.compensaciones !== null ? item.compensaciones : 0.00;
				let monto_horas_extras = item.monto_horas_extras !== undefined && item.monto_horas_extras !== null ? item.monto_horas_extras : 0.00;
				let comisiones_semana = item.comisiones_semana !== undefined && item.comisiones_semana !== null ? item.comisiones_semana : 0.00;
				let monto_total_rebajes = item.monto_total_rebajes !== undefined && item.monto_total_rebajes !== null ? item.monto_total_rebajes : 0.00;
				let monto_total_bonos = item.monto_total_bonos !== undefined && item.monto_total_bonos !== null ? item.monto_total_bonos : 0.00;

				this.formula_monto_total = `
				Monto Jornada Laboral: ${monto_laborado}\n  
				Monto Compensaciones: ${compensaciones}\n  
				Monto Horas Extras: ${monto_horas_extras}\n  
				Monto Comisiones: ${comisiones_semana}\n  
				Monto Bonos: ${monto_total_bonos}\n  
				Monto Rebajes: ${monto_total_rebajes} 
				`;
			},

      // = response.data.horasDobles
			getCiclos () {
				this.cargar = true
				this.ciclos = []

				this.$http.get('roles.ciclos.all').then(response=>{
					for(const i in response.data){
						if (!(response.data[i].ciclo.search('FE') != -1)) {
							if(response.data[i].ciclo.search('CICLO') != -1){
								this.ciclos.push(response.data[i])
							}
						}
					}

					this.cargar = false
				}).catch( error =>{
					this.validarError( error.response.data.message )
				}).finally( () => { this.cargar = false })
			},

			goHorasExtras( name ){
				this.$router.push({name: "HorasExtras", params: { fecha: this.fecha, nombre: name }})
			},
			goPrenomina( name ){
				this.$router.push({name: "nominaActual", params: { fecha: this.fecha, nombre: name } })
			},
			goBonos( name ){
				this.$router.push({name: "BonosVentas", params: { fecha: this.fecha, nombre: name }})
			},
			goRebajes( name ){
				this.$router.push({name: "RebajesNomina", params: { fecha: this.fecha, nombre: name }})
			},
			goComisiones( name ){
				this.$router.push({name: "EncargadasComisiones", params: { fecha: this.fecha, nombre: name }})
			},

			exportExcel(data) {
				const wb = XLSX.utils.book_new();
				data.forEach(sheetData => {
					const ws = XLSX.utils.json_to_sheet(sheetData.data);
					XLSX.utils.book_append_sheet(wb, ws, sheetData.sheetName);
				});

				// Descarga el archivo Excel
				XLSX.writeFile(wb, 'Nomina y Prenomina.xlsx');
			},

			toggleLiberarNomina( ){

				const idCiclo = this.idCicloNomina()
				if( !idCiclo || !this.selectedHeaders ){
					return this.validarErrorDirecto('Selecciona ciclo y semana')
				}

				const ibaALiberar = !this.nominaLiberada
				const payload = {
      		id_ciclo: idCiclo,
      		semana  : this.selectedHeaders,
      		tipo    : 1 
      	}

      	this.cargar = true
        this.$http.post('nomina.liberar', payload ).then(response=>{
          const liberada = response.data && response.data.liberada != null
            ? !!response.data.liberada
            : ibaALiberar
          this.nominaLiberada = liberada
          const msg = (response.data && response.data.message)
            ? response.data.message
            : (liberada ? 'Nómina liberada correctamente' : 'Nómina bloqueada correctamente')
          this.validarSuccess(msg)
          this.cargar = false
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })
			},

			liberarNomina( ){
				this.toggleLiberarNomina()
			},

			puedeLiberarNominaEmpleado(item) {
				return item.estatus_nomina == 1 || item.estatus_nomina == 2
			},

			aceptarNominaEmpleado(item) {
				this.actualizarEstatusNominaEmpleado(item, 1)
			},

			liberarNominaEmpleado(item) {
				this.actualizarEstatusNominaEmpleado(item, 0)
			},

			idCicloNomina() {
				if (!this.ciclo) return null
				if (typeof this.ciclo === 'object' && this.ciclo.id_ciclo != null) {
					return this.ciclo.id_ciclo
				}
				return this.ciclo
			},

			actualizarEstatusNominaEmpleado(item, estatus) {
				if (!this.puedeAccionesNomina) {
					return this.validarErrorDirecto('No tienes permiso para esta acción')
				}
				var self = this
				var idCiclo = this.idCicloNomina()
				if (!idCiclo) {
					return this.validarErrorDirecto('Selecciona un ciclo')
				}
				if (!this.selectedHeaders) {
					return this.validarErrorDirecto('Selecciona una semana')
				}

				this.nominaAccionId = item.id
				this.cargar = true

				var payload = {
					id_usuario: item.id,
					semana: this.selectedHeaders,
					id_ciclo: idCiclo,
					estatus: estatus,
					motivo: '',
				}

				this.$http
					.post('encargadas_comisiones.estatus.nomina', payload)
					.then(function (response) {
						self.validarSuccess(
							response.data.message ||
								(estatus === 1
									? 'Nómina aceptada correctamente'
									: 'Nómina liberada correctamente')
						)
						self.initialize()
					})
					.catch(function (error) {
						self.validarError(
							error.response && error.response.data
								? error.response.data
								: error
						)
					})
					.finally(function () {
						self.cargar = false
						self.nominaAccionId = null
					})
			},

			exportarInscripciones() {
				const empleados = this.filterEntradas.map(({ id, nombre_completo, puesto, monto_laborado, monto_horas_extras, comisiones_semana, monto_total_rebajes, monto_total_bonos, monto_total }) =>
					({ "ID": id,"Empleado":nombre_completo, "Puesto":puesto, "Monto Jornada Laboral":monto_laborado,  "Monto Horas Extras":monto_horas_extras,  "Monto Comisiones":comisiones_semana, "Monto Rebajes":monto_total_rebajes, "Monto Bonos":monto_total_bonos,  "Monto Total":monto_total }));

				const empleados2 = this.filterEntradas.map(({ id, nombre_completo, puesto, plantel, sucursal_registro, fecha_ingreso, dia_laboral, horas_laboradas_total, horas_extras, entrada1, salida1, horas_laboradas1,  entrada2, salida2, horas_laboradas2, entrada3, salida3, horas_laboradas3,  entrada4, salida4, horas_laboradas4,  entrada5, salida5, horas_laboradas5,  entrada6, salida6, horas_laboradas6, entrada7, salida7, horas_laboradas7 }) => 
					({ id, nombre_completo, puesto, plantel, sucursal_registro, fecha_ingreso, dia_laboral, horas_laboradas_total, horas_extras, "Sabado/Entrada": entrada1, "Sabado/Salida":salida1, "Sabado/Horas":horas_laboradas1,  "Domingo/Entrada":entrada2, "Domingo/Salida":salida2, "Domingo/Horas":horas_laboradas2,  "Lunes/Entrada":entrada3, "Lunes/Salida":salida3, "Lunes/Horas":horas_laboradas3,  "Martes/Entrada":entrada4, "Martes/Salida":salida4, "Martes/Horas":horas_laboradas4, "Miercoles/Entrada":entrada5, "Miercoles/Salida":salida5, "Miercoles/Horas":horas_laboradas5, "Jueves/Entrada":entrada6, "Jueves/Salida":salida6, "Jueves/Horas":horas_laboradas6, "Viernes/Entrada":entrada7, "Viernes/Salida":salida7, "Viernes/Horas":horas_laboradas7  }));

				const empleados3 = this.nomina_pasada.map(({ id_trabajador, empleado, puesto, plantel, monto_total_sin_comisiones, monto_total_actual, monto_total_diferencia}) => 
					({ id_trabajador, empleado, puesto, plantel, "Monto Anterior": monto_total_sin_comisiones, "Monto Actual": monto_total_actual, "Monto Diferencia": monto_total_diferencia }));

				const empleados4 = this.filterEntradasEncargadas.map(({ id, nombre_completo, puesto, plantel, comisiones_semana}) => 
					({ id, nombre_completo, puesto, plantel, "Comisiones": comisiones_semana }));

				this.exportExcel([
					{ sheetName: 'Nomina', data: empleados },
					{ sheetName: 'Prenomina', data: empleados2 }, // Segunda pestaña con los mismos datos
					{ sheetName: 'Comparativa', data: empleados3 }, // Segunda pestaña con los mismos datos
					{ sheetName: 'Comisiones', data: empleados4 } // Segunda pestaña con los mismos datos
				]);
			},

			responder( ){

				const payload = {
					idnomina_estatus: this.renglonNomina.idnomina_estatus,
					estatus         : 0,
					id_usuario      : this.getdatosUsuarioERPERP.id_trabajador,
					motivo          : this.respuesta,
					idusuarionomina : this.renglonNomina.id_usuario 
				}

				this.$http.post('responder.nomina', payload ).then(response=>{
          this.validarSuccess( 'Respuesta enviada' )
          this.initialize( )
          this.dialogComentarios = false
          this.respuesta = ''
        	this.cargar      = false
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })


			},

			format( valor ){
			  return valor.toLocaleString('es-MX', {
			    style: 'currency',
			    currency: 'MXN'
			  });
      }
		},
	}
</script>

